window.theme = window.theme || {}, void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function (e, t) {
  return function () {
    return e.apply(t, arguments)
  }
}, Shopify.setSelectorByValue = function (e, t) {
  for (var s = 0, i = e.options.length; s < i; s++) {
    var r = e.options[s];
    if (t == r.value || t == r.innerHTML) return e.selectedIndex = s
  }
}, Shopify.addListener = function (e, t, s) {
  e.addEventListener ? e.addEventListener(t, s, !1) : e.attachEvent("on" + t, s)
}, Shopify.postLink = function (e, t) {
  var s, i = (t = t || {}).method || "post",
    r = t.parameters || {},
    a = document.createElement("form");
  for (s in a.setAttribute("method", i), a.setAttribute("action", e), r) {
    var o = document.createElement("input");
    o.setAttribute("type", "hidden"), o.setAttribute("name", s), o.setAttribute("value", r[s]), a.appendChild(o)
  }
  document.body.appendChild(a), a.submit(), document.body.removeChild(a)
}, Shopify.CountryProvinceSelector = function (e, t, s) {
  this.countryEl = document.getElementById(e), this.provinceEl = document.getElementById(t), this.provinceContainer = document.getElementById(s.hideElement || t), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var e = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
  },
  initProvince: function () {
    var e = this.provinceEl.getAttribute("data-default");
    e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e)
  },
  countryHandler: function (e) {
    var t = (i = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
      s = JSON.parse(t);
    if (this.clearOptions(this.provinceEl), s && 0 == s.length) this.provinceContainer.style.display = "none";
    else {
      for (var i, r = 0; r < s.length; r++)(i = document.createElement("option")).value = s[r][0], i.innerHTML = s[r][1], this.provinceEl.appendChild(i);
      this.provinceContainer.style.display = ""
    }
  },
  clearOptions: function (e) {
    for (; e.firstChild;) e.removeChild(e.firstChild)
  },
  setOptions: function (e, t) {
    var s = 0;
    for (t.length; s < t.length; s++) {
      var i = document.createElement("option");
      i.value = t[s], i.innerHTML = t[s], e.appendChild(i)
    }
  }
}, theme.config = {
  mediaQueries: {
    landscapeAll: "screen and (orientation: landscape)",
    landscape: "screen and (orientation: landscape), screen and (min-width: 48rem)",
    belowTablet: "screen and (max-width: 47.99rem)",
    tablet: "screen and (min-width: 48rem)",
    belowLaptop: "screen and (max-width: 63.99rem)",
    laptop: "screen and (min-width: 64rem)",
    belowDesktop: "screen and (max-width: 64rem)",
    desktop: "screen and (min-width: 64.01rem)",
    belowWidescreen: "screen and (max-width: 79.99rem)",
    widescreen: "screen and (min-width: 80rem)",
    belowExtrawide: "screen and (max-width: 89.99rem)",
    extrawide: "screen and (min-width: 90rem)"
  },
  money: {
    format: `${window.currency.symbol || "$"}{{amount_no_decimals}}`,
    currencySymbols: {
      USD: "$",
      CAD: "$",
      EUR: "€",
      CRC: "₡",
      GBP: "£",
      ILS: "₪",
      INR: "₹",
      JPY: "¥",
      KRW: "₩",
      NGN: "₦",
      PHP: "₱",
      PLN: "zł",
      PYG: "₲",
      THB: "฿",
      UAH: "₴",
      VND: "₫"
    }
  },
  upsellLimit: 6
}, theme.utils = {
  subscriptions: {
    subscribers: {},
    subscribe(e, t) {
      return void 0 === theme.utils.subscriptions.subscribers[e] && (theme.utils.subscriptions.subscribers[e] = []), theme.utils.subscriptions.subscribers[e] = [...theme.utils.subscriptions.subscribers[e], t],
        function () {
          theme.utils.subscriptions.subscribers[e] = theme.utils.subscriptions.subscribers[e].filter(e => e !== t)
        }
    },
    publish(e, t) {
      theme.utils.subscriptions.subscribers[e] && theme.utils.subscriptions.subscribers[e].forEach(e => {
        e(t)
      })
    }
  },
  a11y: {
    getFocusableElements(e) {
      return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
    },
    _trapFocusHandlers: {},
    trapFocus(t, e = t) {
      var s = theme.utils.a11y.getFocusableElements(t),
        i = s[0],
        r = s[s.length - 1];
      theme.utils.a11y.removeTrapFocus(), theme.utils.a11y._trapFocusHandlers.focusin = e => {
        e.target !== t && e.target !== r && e.target !== i || document.addEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown)
      }, theme.utils.a11y._trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown)
      }, theme.utils.a11y._trapFocusHandlers.keydown = function (e) {
        "TAB" === e.code.toUpperCase() && (e.target !== r || e.shiftKey || (e.preventDefault(), i.focus()), e.target === t || e.target === i) && e.shiftKey && (e.preventDefault(), r.focus())
      }, document.addEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout), document.addEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin), e && e.focus()
    },
    removeTrapFocus(e = null) {
      document.removeEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin), document.removeEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout), document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown), e && e.focus()
    }
  },
  prepareTransition(e) {
    e.addEventListener("transitionend", () => {
      e.classList.remove("is-transitioning")
    });
    let t = 0;
    const s = getComputedStyle(e);
    ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"].forEach(e => t = t || parseFloat(s.getPropertyValue(e))), 0 != t && (e.classList.add("is-transitioning"), e.offsetWidth)
  },
  defaultTo: function (e, t) {
    return null == e || e != e ? t : e
  },
  formatMoney(e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    var s = "",
      a = /\{\{\s*(\w+)\s*\}\}/,
      o = t || theme.config.money.format;

    function i(e, t, s, i) {
      if (t = theme.utils.defaultTo(t, 2), s = theme.utils.defaultTo(s, ","), i = theme.utils.defaultTo(i, "."), isNaN(e) || null == e) return 0;
      t = (e = (e / 100).toFixed(t)).split("."), e = t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s);
      let r = t[1] ? i + t[1] : "";
      return e + (r = "no_trailing_zeros" == o.match(a)[1] && ".00" == r ? "" : r)
    }
    switch (o.match(a)[1]) {
      case "amount":
        s = i(e, 2);
        break;
      case "amount_no_decimals":
        s = i(e, 0);
        break;
      case "amount_with_space_separator":
        s = i(e, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        s = i(e, 0, ",", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        s = i(e, 0, " ");
        break;
      case "no_trailing_zeros":
        s = i(e, 2)
    }
    return o.replace(a, s)
  },
  serializeForm: e => {
    var t = {},
      s = new FormData(e);
    for (const r of s.keys()) {
      var i = /(?:^(properties\[))(.*?)(?:\]$)/;
      i.test(r) ? (t.properties = t.properties || {}, t.properties[i.exec(r)[2]] = s.get(r)) : t[r] = s.get(r)
    }
    return JSON.stringify(t)
  },
  debounce(t, s) {
    let i;
    return (...e) => {
      clearTimeout(i), i = setTimeout(() => t.apply(this, e), s)
    }
  },
  getSiblings(e, t) {
    var s, i = [];
    let r;
    for (s of r = t ? e.parentNode.querySelectorAll(":scope > " + t) : e.parentNode.children) s !== e && i.push(s);
    return i
  },
  refreshElements(e, t, s) {
    e.forEach(e => {
      const a = t.querySelectorAll(e);
      s.querySelectorAll(e).forEach((e, t) => {
        var s, i, r;
        a[t] ? null != e.getAttribute("js-accordion-item") ? (s = e.querySelector("[js-accordion-header]").getAttribute("aria-expanded"), i = e.querySelector("[js-accordion-content]").getAttribute("aria-hidden"), (r = a[t]).querySelector("[js-accordion-header]").setAttribute("aria-expanded", s), r.querySelector("[js-accordion-content]").setAttribute("aria-hidden", i), e.innerHTML = r.innerHTML) : e.innerHTML = a[t].innerHTML : e.remove()
      })
    })
  },
  handleize(e) {
    return e.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "")
  },
  getCookie(e) {
    for (var t = e + "=", s = decodeURIComponent(document.cookie).split(";"), i = 0; i < s.length; i++) {
      for (var r = s[i];
        " " == r.charAt(0);) r = r.substring(1);
      if (0 == r.indexOf(t)) return r.substring(t.length, r.length)
    }
    return ""
  },
  setCookie(e, t, s) {
    var i = new Date,
      s = (i.setTime(i.getTime() + 24 * s * 60 * 60 * 1e3), "expires=" + i.toUTCString());
    document.cookie = e + "=" + t + ";" + s + ";path=/"
  }
};
class FocusableWidget extends HTMLElement {
  constructor(e = {}) {
    if (super(), !e.name) throw new Error(`Focusable Widget(${e.name}) must have a name`);
    if (!this.id) throw new Error(e.name + " must have an id");
    if (!e.background) throw new Error(`Focusable Widget(${e.name}) must have a background`);
    this._clientConfig = e, this._init(e)
  }
  open = () => {
    if (!this._isOpen) return this._closeFocusableWidgets(), this.toggle()
  };
  close = () => {
    if (this._isOpen) return this.toggle()
  };
  toggle = () => (theme.utils.prepareTransition(this), this._toggleClasses(), this._toggleAccessibilityAttributes(), this._isOpen ? (theme.utils.a11y.removeTrapFocus(this), this._unbindEvents(), this._dispatchEvents(this._events.close, ["close"])) : (theme.utils.a11y.trapFocus(this), this._bindEvents(), this._dispatchEvents(this._events.open, ["open"])), this._isOpen = !this._isOpen, this);
  reinitWidget = () => {
    this._init(this._clientConfig)
  };
  get isOpen() {
    return this._isOpen
  }
  _init({
    name: e,
    background: t,
    widgetOpenClasses: s = [],
    bodyOpenClasses: i = [],
    attributes: r = {}
  }) {
    this._name = e, this._isOpen = !1, this._selectors = {
      background: t,
      open: this.getAttribute("open"),
      close: this.getAttribute("close")
    }, this._nodes = {
      background: document.querySelector(this._selectors.background)
    }, this._events = {
      open: ["focusable-widget:open", e + ":open", this.id + ":open"],
      close: ["focusable-widget:close", e + ":close", this.id + ":close"]
    }, this._config = {
      open: document.querySelectorAll(this._selectors.open),
      close: document.querySelectorAll(this._selectors.close),
      attributes: {
        "data-focusable-widget": "true",
        "aria-hidden": "true",
        tabindex: 0,
        ...r
      },
      widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(s),
      bodyOpenClasses: ["js-focusable-widget-open", `js-${e}-open`, this.getAttribute("body-open-class")].concat(i)
    }, this._validateConfig(), this._addAccessibilityAttributes(), this._setupListeners()
  }
  _validateConfig() {
    if (this._config.open && this._config.open.length || console.warn(`WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`), !this._config.close || !this._config.close.length) throw new Error(`${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`)
  }
  _setupListeners() {
    this._config.open.forEach(e => e.addEventListener("click", this._open.bind(this))), this._config.close.forEach(e => e.addEventListener("click", this._close.bind(this))), this.addEventListener("click", e => e.stopPropagation())
  }
  _open(e) {
    e && (e.preventDefault(), e.stopPropagation()), this.open()
  }
  _close = e => {
    e && (e.preventDefault(), e.stopPropagation()), this.close()
  };
  _closeFocusableWidgets() {
    document.querySelectorAll("[data-focusable-widget].open").forEach(e => e.close())
  }
  _dispatchEvents(e, t) {
    e.forEach(e => document.dispatchEvent(new CustomEvent(e))), t && t.length && t.forEach(e => this.dispatchEvent(new CustomEvent(e)))
  }
  _bindEvents() {
    document.addEventListener("keyup", this._onKeyUp), this._nodes.background.addEventListener("click", this._close), this._nodes.background.addEventListener("touchmove", this._onTouchMove)
  }
  _unbindEvents() {
    document.removeEventListener("keyup", this._onKeyUp), this._nodes.background.removeEventListener("click", this._close), this._nodes.background.removeEventListener("touchmove", this._onTouchMove)
  }
  _toggleClasses() {
    this._isOpen ? (this._config.bodyOpenClasses.forEach(e => {
      e && document.body.classList.remove(e)
    }), this._config.widgetOpenClasses.forEach(e => {
      e && this.classList.remove(e)
    })) : (this._config.bodyOpenClasses.forEach(e => {
      e && document.body.classList.add(e)
    }), this._config.widgetOpenClasses.forEach(e => {
      e && this.classList.add(e)
    }))
  }
  _toggleAccessibilityAttributes() {
    this._isOpen ? (this.setAttribute("aria-hidden", "true"), this.setAttribute("tabindex", "-1"), this._config.open.forEach(e => e.setAttribute("aria-expanded", "false")), this._config.close.forEach(e => e.setAttribute("aria-expanded", "false"))) : (this.setAttribute("aria-hidden", "false"), this.setAttribute("tabindex", "0"), this._config.open.forEach(e => e.setAttribute("aria-expanded", "true")), this._config.close.forEach(e => e.setAttribute("aria-expanded", "true")))
  }
  _addAccessibilityAttributes() {
    var e = e => {
      e.setAttribute("tabindex", "0"), e.setAttribute("aria-expanded", "false"), e.setAttribute("aria-controls", this.id)
    };
    for (const t in this._config.attributes) this.setAttribute(t, this._config.attributes[t]);
    this._config.open.forEach(e), this._config.close.forEach(e)
  }
  _onKeyUp = e => {
    "ESCAPE" === e.code.toUpperCase() && this.close()
  };
  _onTouchMove = () => !1
}
class Drawer extends FocusableWidget {
  constructor() {
    super({
      name: "drawer",
      background: ".drawer-background"
    });
    var e = this.getAttribute("position");
    if (!e) throw new Error("drawer must have position attribute");
    this._position = e, this._config.bodyOpenClasses.push(`js-drawer-${e}-open`), this._clientConfig.bodyOpenClasses = [`js-drawer-${e}-open`]
  }
  get position() {
    return this._position
  }
}
class Modal extends FocusableWidget {
  constructor() {
    super({
      name: "modal",
      background: ".modal-background",
      bodyOpenClasses: "js-modal-open"
    })
  }
}
class Accordion extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      accordion: "[js-accordion]",
      accordionItem: "[js-accordion-item]",
      accordionHeader: "[js-accordion-header]",
      accordionContent: "[js-accordion-content]"
    }
  }
  connectedCallback() {
    this.buttons = this.querySelectorAll(this._selectors.accordionHeader), this.buttons.forEach(e => {
      e.addEventListener("click", this._toggleContent)
    }), this.content = this.querySelectorAll(this._selectors.accordionContent)
  }
  _toggleContent = e => {
    e.stopImmediatePropagation();
    var e = e.currentTarget,
      t = this.querySelector("#" + e.getAttribute("aria-controls")),
      s = theme.utils.getSiblings(e.parentElement, this._selectors.accordionItem);
    "false" == e.getAttribute("aria-expanded") ? (e.setAttribute("aria-expanded", !0), theme.utils.prepareTransition(t), this._expandSection(t), this.dataset.manualCollapse || s.forEach(e => {
      var t = e.querySelector(this._selectors.accordionHeader),
        e = e.querySelector("#" + t.getAttribute("aria-controls"));
      "true" == t.getAttribute("aria-expanded") && (t.setAttribute("aria-expanded", !1), this._collapseSection(e))
    })) : (e.setAttribute("aria-expanded", !1), this._collapseSection(t))
  };
  _collapseSection(e) {
    e.setAttribute("aria-hidden", !0)
  }
  _expandSection(e) {
    e.setAttribute("aria-hidden", !1)
  }
}
class Tabs extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this._elements = {
      tabs: this.querySelectorAll("[js-tab]"),
      tabList: this.querySelectorAll("[js-tab-list]"),
      tabPanel: this.querySelectorAll("[js-tab-panel]")
    }, this._tabEventListener(), this._tabListListener()
  }
  _tabEventListener = () => {
    var e = this._elements["tabs"];
    e.forEach(e => e.addEventListener("click", this._showTabPanel))
  };
  _showTabPanel = e => {
    var t = this._elements["tabs"];
    for (let e = 0; e < t.length; e++) t[e].setAttribute("aria-selected", "false");
    e.target.setAttribute("aria-selected", "true");
    var s = e.target.getAttribute("aria-controls"),
      i = document.querySelectorAll("[role=tabpanel]");
    for (let e = 0; e < i.length; e++) i[e].setAttribute("aria-hidden", "true");
    this.dataset.enableScrollIntoView && e.currentTarget.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    }), document.getElementById(s).setAttribute("aria-hidden", "false")
  };
  _tabListListener = () => {
    var e = this._elements["tabList"];
    e.forEach(e => e.addEventListener("keydown", this._tabListKeydown))
  };
  _tabListKeydown = e => {
    37 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()), 38 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()), 39 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault()), 40 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault())
  }
}
class Carousel extends HTMLElement {
  constructor() {
    super(), this.selectors = {
      carousel: "[js-carousel]"
    }, this.options = {
      loop: !0,
      slidesPerView: "auto",
      grabCursor: !0,
      centeredSlides: !1,
      navigation: !1,
      pagination: !1
    }
  }
  connectedCallback() {
    var e = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    this.options = Object.assign(this.options, e), this._initCarousel()
  }
  _initCarousel() {
    let e = "#" + this.querySelector(this.selectors.carousel).id;
    void 0 !== this.dataset.init ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
      match: function () {
        this.carousel = new Swiper(e, this.options)
      }.bind(this),
      unmatch: function () {
        this.carousel.el.classList.contains("swiper-initialized") && this.carousel.destroy(!0, !0)
      }.bind(this)
    }) : this.carousel = new Swiper(e, this.options)
  }
}
class SiteHeader extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      header: ".shopify-section-header",
      utilityBar: "[js-utility-bar]",
      megaMenuTrigger: "[js-mega-menu-trigger]",
      megaMenuDrawer: "#megaMenuDrawer",
      megaMenu: "[js-mega-menu]"
    }
  }
  connectedCallback() {
    this.header = document.querySelector(this._selectors.header), this.utilityBar = document.querySelector(this._selectors.utilityBar), this.megaMenuTriggers = this.querySelectorAll(this._selectors.megaMenuTrigger), this.megaMenuDrawer = document.querySelector(this._selectors.megaMenuDrawer), this.megaMenus = this.megaMenuDrawer.querySelector(this._selectors.megaMenu), this._setVariables(), this._watchWindowResize(), "index" == this.dataset.template && document.addEventListener("scroll", this._headerOnScroll), this.megaMenuTriggers.forEach(e => {
      e.addEventListener("click", this._megaMenuTriggerOnClick)
    }), this.megaMenuDrawer.addEventListener("close", this._deactivateLastActiveTriggerAndMenu)
  }
  _deactivateLastActiveTriggerAndMenu = () => {
    var e = this.querySelector(this._selectors.megaMenuTrigger + '[data-active="true"]'),
      e = (e && (e.dataset.active = "false"), this.megaMenuDrawer.querySelector(this._selectors.megaMenu + '[data-active="true"]'));
    e && (e.dataset.active = "false")
  };
  _megaMenuTriggerOnClick = e => {
    e.stopPropagation();
    e = e.currentTarget;
    "true" == e.dataset.active ? this.megaMenuDrawer.close() : (this._deactivateLastActiveTriggerAndMenu(), e.dataset.active = "true", this.megaMenuDrawer.querySelector(`${this._selectors.megaMenu}[data-handle="${e.dataset.handle}"]`).dataset.active = "true", this.megaMenuDrawer.open())
  };
  _headerOnScroll = () => {
    0 < window.scrollY ? this.classList.add("bg-blue-dark") : this.classList.remove("bg-blue-dark")
  };
  _watchWindowResize = () => {
    window.addEventListener("resize", this._setVariables)
  };
  _setVariables = () => {
    document.documentElement.style.setProperty("--header-height", this.header.clientHeight + "px"), document.documentElement.style.setProperty("--utility-bar-height", this.utilityBar.clientHeight + "px")
  }
}
class VideoPlayer extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      playBtn: "[js-play]",
      overlay: "[js-overlay]",
      video: "[js-video]"
    }
  }
  connectedCallback() {
    this.playBtn = this.querySelector(this._selectors.playBtn), this.overlay = this.querySelector(this._selectors.overlay), this.video = this.querySelector(this._selectors.video), this._setListeners()
  }
  _setListeners = () => {
    this.playBtn.addEventListener("click", this._playVideo), this.video.addEventListener("pause", this._pauseVideo)
  };
  _playVideo = () => {
    this.overlay.classList.add("hidden"), this.video.play(), this.video.setAttribute("controls", "true")
  };
  _pauseVideo = () => {
    this.video.removeAttribute("controls"), this.overlay.classList.remove("hidden")
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", e => {
      e.preventDefault(), (this.closest("cart-items") || this.closest("cart-drawer-items")).updateQuantity(this.dataset.index, 0)
    })
  }
}
class CartItems extends HTMLElement {
  constructor() {
    super();
    var e = theme.utils.debounce(e => {
      this.onChange(e)
    }, 300);
    this.addEventListener("change", e.bind(this))
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = theme.utils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, e => {
      "cart-items" !== e.source && this.onCartUpdate()
    })
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
  }
  refreshGwp(e) {
    if ("true" === this.dataset.gwpEnabled) {
      var t = [],
        s = {},
        i = this.dataset.gwpVariantId,
        r = this.dataset.gwpVariantIdTag1,
        a = this.dataset.gwpVariantIdTag2,
        o = this.dataset.gwpVariantIdTag3;
      const c = document.querySelector("cart-drawer");
      var n = document.getElementById("CartPage-CartItems")?.dataset?.id,
        e = e?.sections?.cart || e?.sections?.[n];
      switch (e && (e = (n = (new DOMParser).parseFromString(e, "text/html")).querySelector("cart-drawer-items") || n.querySelector("cart-items")) && (this.dataset.gwpAction = e.getAttribute("data-gwp-action"), this.dataset.gwpActionTag1 = e.getAttribute("data-gwp-action-tag1"), this.dataset.gwpActionTag2 = e.getAttribute("data-gwp-action-tag2"), this.dataset.gwpActionTag3 = e.getAttribute("data-gwp-action-tag3")), this.dataset.gwpAction) {
        case "add":
          t.push({
            id: i,
            quantity: 1,
            properties: {
              _gwp: !0
            }
          });
          break;
        case "remove":
          s[i] = 0
      }
      switch (this.dataset.gwpActionTag1) {
        case "add":
          t.push({
            id: r,
            quantity: 1,
            properties: {
              _gwp: !0
            }
          });
          break;
        case "remove":
          s[r] = 0
      }
      switch (this.dataset.gwpActionTag2) {
        case "add":
          t.push({
            id: a,
            quantity: 1,
            properties: {
              _gwp: !0
            }
          });
          break;
        case "remove":
          s[a] = 0
      }
      switch (this.dataset.gwpActionTag3) {
        case "add":
          t.push({
            id: o,
            quantity: 1,
            properties: {
              _gwp: !0
            }
          });
          break;
        case "remove":
          s[o] = 0
      }
      0 < t.length && (n = JSON.stringify({
        items: t,
        sections: this.getSectionsToRender().map(e => e.section),
        sections_url: window.location.pathname
      }), fetch("" + window.routes.cart_add_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: n
      }).then(e => e.json()).then(t => {
        "/cart" == window.location.pathname ? this.getSectionsToRender().forEach(e => {
          (document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.section], e.selector)
        }) : c.renderContents(t)
      })), 0 < Object.keys(s).length && (e = JSON.stringify({
        updates: s,
        sections: this.getSectionsToRender().map(e => e.section),
        sections_url: window.location.pathname
      }), fetch("" + window.routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: e
      }).then(e => e.json()).then(t => {
        "/cart" == window.location.pathname ? this.getSectionsToRender().forEach(e => {
          (document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.section], e.selector)
        }) : c.renderContents(t)
      }))
    }
  }
  onChange(e) {
    this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name"))
  }
  onCartUpdate() {
    fetch(routes.cart_url + "?section_id=cart__main").then(e => e.text()).then(e => {
      e = (new DOMParser).parseFromString(e, "text/html").querySelector("cart-items");
      this.innerHTML = e.innerHTML, this.dataset.gwpAction = e.getAttribute("data-gwp-action"), this.dataset.gwpActionTag1 = e.getAttribute("data-gwp-action-tag1"), this.dataset.gwpActionTag2 = e.getAttribute("data-gwp-action-tag2"), this.dataset.gwpActionTag3 = e.getAttribute("data-gwp-action-tag3"), this.refreshGwp()
    }).catch(e => {
      console.error(e)
    })
  }
  getSectionsToRender() {
    return [{
      id: "CartPage-CartItems",
      section: document.getElementById("CartPage-CartItems").dataset.id,
      selector: "[js-cart-page-contents]"
    }]
  }
  updateQuantity(o, e, n) {
    this.enableLoading(o);
    e = JSON.stringify({
      line: o,
      quantity: e,
      sections: this.getSectionsToRender().map(e => e.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: e
    }).then(e => e.text()).then(t => {
      const s = JSON.parse(t);
      this.refreshGwp(s);
      var t = document.getElementById("Quantity-" + o) || document.getElementById("Drawer-quantity-" + o),
        i = document.querySelectorAll("[js-cart-item]");
      if (s.errors) t.value = t.getAttribute("value"), this.updateLiveRegions(o, s.errors);
      else {
        var r = document.querySelector("cart-drawer"),
          a = (this.getSectionsToRender().forEach(e => {
            (document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(s.sections[e.section], e.selector)
          }), s.items[o - 1] ? s.items[o - 1].quantity : void 0);
        let e = "";
        i.length === s.items.length && a !== parseInt(t.value) && (e = void 0 === a ? "There was an error while updating your cart. Please try again." : `You can only add ${a} of this item to your cart.`), this.updateLiveRegions(o, e);
        i = document.getElementById("CartItem-" + o) || document.getElementById("CartDrawer-Item-" + o);
        i && i.querySelector(`[name="${n}"]`) ? r ? theme.utils.a11y.trapFocus(r, i.querySelector(`[name="${n}"]`)) : i.querySelector(`[name="${n}"]`).focus() : 0 === s.item_count && r ? theme.utils.a11y.trapFocus(r.querySelector("[js-empty-cart]"), r.querySelector("[js-cart-continue-link]")) : document.querySelector("[js-cart-item]") && r && theme.utils.a11y.trapFocus(r, document.querySelector("[js-cart-item-image]")), theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items"
        })
      }
    }).catch(e => {
      console.log(e), this.querySelectorAll(".loading-overlay").forEach(e => e.classList.add("hidden")), (document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")).textContent = "There was an error while updating your cart. Please try again."
    }).finally(() => {
      this.disableLoading(o)
    })
  }
  updateLiveRegions(e, t) {
    e = document.getElementById("Line-item-error-" + e) || document.getElementById("CartDrawer-LineItemError-" + e);
    e && (e.innerHTML = t)
  }
  getSectionInnerHTML(e, t) {
    return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
  }
  enableLoading(e) {
    (document.getElementById("CartPage-CartItems") || document.getElementById("CartDrawer-CartItems")).classList.add("cart__items--disabled");
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach(e => e.setAttribute("loading", "")), document.activeElement.blur()
  }
  disableLoading(e) {
    (document.getElementById("CartPage-CartItems") || document.getElementById("CartDrawer-CartItems")).classList.remove("cart__items--disabled");
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach(e => e.removeAttribute("loading"))
  }
}
class CartNote extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", debounce(e => {
      e = JSON.stringify({
        note: e.target.value
      });
      fetch("" + routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: e
      })
    }, ON_CHANGE_DEBOUNCE_TIMER))
  }
}
class CartDrawer extends HTMLElement {
  constructor() {
    super()
  }
  renderContents(t) {
    this.productId = t.id, this.getSectionsToRender().forEach(e => {
      (e.selector ? document.querySelector(e.selector) : document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector)
    })
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
  }
  getSectionsToRender() {
    return [{
      id: "cart",
      selector: "#cart"
    }, {
      id: "cart-count"
    }]
  }
  getSectionDOM(e, t = ".shopify-section") {
    return (new DOMParser).parseFromString(e, "text/html").querySelector(t)
  }
  setActiveElement(e) {
    this.activeElement = e
  }
}
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [{
      id: "cart",
      section: "cart",
      selector: "[js-cart-drawer-contents]"
    }, {
      id: "cart-count",
      section: "cart-count",
      selector: ".shopify-section"
    }]
  }
}
class ProductOptions extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      singleOptionSelector: "[js-product-option-selector]"
    }, this._events = {
      change: "variant:change",
      fetchBefore: "variant:fetch:before",
      fetchAfter: "variant:fetch:after",
      fetchError: "variant:fetch:error"
    }
  }
  connectedCallback() {
    var e;
    this._handle = this.dataset.productHandle, this._masterSelect = document.getElementById(this.dataset.masterSelectId), this.availabilityLabels = {
      available: "ご利用可能なオプション",
      outOfStock: "売り切れ"
    }, this._checkAvailableOptions = !this.hasAttribute("data-disable-option-binding"), this._optionSelectors = [...this.querySelectorAll(this._selectors.singleOptionSelector)], this._numMultiValuesOptions = parseInt(this.dataset.numMultiValuesOptions), this._checkAvailableOptions && (this._availableValues = {}, this._lastSelectedOption = {
      option1: null,
      option2: null,
      option3: null,
      lastSelected: null
    }, this._option1Values = this._option2Values = this._option3Values = null), this.dataset.product && (e = document.getElementById(this.dataset.product)) && (this._product = JSON.parse(e.innerHTML)), this._product && (this._currentVariant = this._getVariantFromOptions(), this._checkAvailableOptions) && this._setupOptionsAvailability(this._product), (this._product || this._handle) && this._setupListeners()
  }
  set product(e) {
    this._product = e, this.disconnectedCallback(), this.connectedCallback()
  }
  _setupListeners() {
    this._optionSelectors.forEach(e => e.addEventListener("change", this._handleOptionChange))
  }
  _getVariantFromOptions() {
    if (this._product) {
      const s = this._getCurrentOptions();
      var e = this._product["variants"];
      return s.length >= this._numMultiValuesOptions ? e.find(t => s.every(e => e.value === this._formatOptionLabel(t[e.index]))) : void 0
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors.map(e => {
      var t = e.getAttribute("type"),
        s = {};
      return ("radio" !== t && "checkbox" !== t || !!e.checked) && (s.value = e.value, s.index = e.dataset.index, s)
    }).filter(e => e)
  }
  _formatOptionLabel(e) {
    return e.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, "-").replace(/-$/, "").replace(/^-/, "")
  }
  _setupOptionsAvailability(r) {
    this._option1Values = new Set, this._option2Values = new Set, this._option3Values = new Set, r.variants.forEach(e => {
      var {
        option1: e,
        option2: t,
        option3: s
      } = e;
      e && this._option1Values.add(this._formatOptionLabel(e)), t && this._option2Values.add(this._formatOptionLabel(t)), s && this._option3Values.add(this._formatOptionLabel(s))
    });
    const a = new Map,
      o = [
        [...this._option1Values],
        [...this._option2Values],
        [...this._option3Values].filter(Boolean)
      ].filter(e => 0 < e.length),
      n = (t = [], s = 0) => {
        var e, i;
        s === o.length ? (e = 0 < (i = r.variants.filter(s => t.every((e, t) => this._formatOptionLabel(s["option" + (t + 1)]) === e))).length, i = i.some(e => !0 === e.available), a.set(JSON.stringify(t), {
          exists: e,
          available: i
        })) : o[s].forEach(e => {
          n([...t, e], s + 1)
        })
      };
    n(), this._variantMatrix = a;
    var e = this._setLastSelected();
    this._availableValues = this._getAvailableValues(this._product, e), this._refreshValuesUI(this._availableValues)
  }
  _setLastSelected() {
    var e;
    return this._optionSelectors.forEach(e => {
      var t = e.dataset.index,
        s = e.value;
      e.checked ? this._lastSelectedOption[t] = s : this._lastSelectedOption[t] === s && (this._lastSelectedOption[t] = null)
    }), !this._lastSelectedOption?.lastSelected && this._currentVariant && (e = this._currentVariant.options.length, this._lastSelectedOption.lastSelected = "option" + e), this._lastSelectedOption
  }
  _handleOptionChange = t => {
    this._product ? this._updateVariant(t) : this._fetchProduct(this._handle).then(e => {
      this._product = e, this._checkAvailableOptions && this._setupOptionsAvailability(this._product), this._updateVariant(t)
    }).catch(e => console.log(e)), this.dispatchEvent(new CustomEvent(this._events.optionChange, {
      detail: {
        value: t.target.value,
        key: t.target.getAttribute("data-index")
      },
      bubbles: !0
    })), this._checkAvailableOptions && (this._lastSelectedOption[t.target.dataset.index] = t.target.value, this._lastSelectedOption.lastSelected = t.target.dataset.index, e = this._handleOptionsAvailability(this._lastSelectedOption), this._refreshValuesUI(e), this._availableValues = e);
    var e = this._getCurrentOptions();
    e.length === this._numMultiValuesOptions ? this._updateVariant(t) : this._removeVariant()
  };
  _updateVariant(e) {
    this._checkAvailableOptions && (this._lastSelectedOption[e.target.dataset.index] = e.target.value, this._lastSelectedOption.lastSelected = e.target.dataset.index);
    var t, s, e = this._getVariantFromOptions();
    this.dispatchEvent(new CustomEvent(this._events.change, {
      detail: {
        variant: e,
        priceChange: this._hasPriceChanged(e)
      },
      bubbles: !0
    })), this._checkAvailableOptions && (t = this._getAvailableValues(this._product, this._lastSelectedOption), s = this._getDifference(this._availableValues, t), this._refreshValuesUI(s), this._availableValues = t), this.hasAttribute("data-enable-history-state") && this._updateHistoryState(e), this._masterSelect && this._updateMasterSelect(e), this._currentVariant = e
  }
  _removeVariant() {
    this.dispatchEvent(new CustomEvent(this._events.change, {
      detail: {
        variant: null,
        defaultVariant: this._product.variants[0]
      },
      bubbles: !0
    })), this.hasAttribute("data-enable-history-state") && this._updateHistoryState(), this._masterSelect && this._updateMasterSelect(), this._currentVariant = null
  }
  _hasPriceChanged(e) {
    return !(!e || !this._currentVariant || e.price === this._currentVariant.price && e.compare_at_price === this._currentVariant.compare_at_price)
  }
  _setCurrentOptions(s) {
    this._optionSelectors.forEach(e => {
      var t = e.getAttribute("data-index"),
        t = s[t];
      t && void 0 !== t[e.value] && (e.checked = t[e.value])
    }), this._setLastSelected()
  }
  _handleOptionsAvailability() {
    let e = this._getAvailableValues(this._product, this._lastSelectedOption);
    const t = this._lastSelectedOption.lastSelected;
    let s = !0;
    this._availableValues[t] && (i = this._availableValues[t].find(e => e.value === this._lastSelectedOption[t]))?.exists && !i?.available && (s = !0);
    var i = this._findOptionsToDeselect(e);
    return Object.values(i).some(e => null !== e) && (this._setCurrentOptions(i), e = this._getAvailableValues(this._lastSelectedOption)), s && (i = this._findNextAvailableOptions(e)) && this._setCurrentOptions(i), e
  }
  _findOptionsToDeselect(e) {
    const i = {};
    return Object.entries(e).forEach(([e, t]) => {
      const s = this._lastSelectedOption[e];
      !s || e === this._lastSelectedOption.lastSelected || (t = t.find(e => e.value === s))?.exists || t?.available || (i[e] = {
        [s]: !1
      })
    }), i
  }
  _findNextAvailableOptions(s) {
    const i = {
      ...this._lastSelectedOption
    };
    return Object.keys(s).sort().forEach(e => {
      var t;
      i[e] || 1 === (t = s[e].filter(e => e.exists && e.available || e.exists && !e.available)).length && (i[e] = {
        [t[0].value]: !0
      }, i.lastSelected = e)
    }), 1 < Object.keys(i).length && i
  }
  _getAvailableValues(e, r = this._lastSelectedOption) {
    if (r?.lastSelected) {
      const s = {},
        a = [
          [...this._option1Values],
          [...this._option2Values],
          [...this._option3Values].filter(Boolean)
        ].filter(e => 0 < e.length);
      return a.forEach((e, i) => {
        var t = "option" + (i + 1);
        s[t] = e.map(s => {
          const t = a.map((e, t) => t === i ? s : r["option" + (t + 1)]);
          var e = [...this._variantMatrix.entries()].filter(([e]) => {
            const s = JSON.parse(e);
            return t.every((e, t) => null === e || e === s[t])
          });
          return {
            value: s,
            exists: e.some(([, e]) => e.exists),
            available: e.some(([, e]) => e.available)
          }
        })
      }), s
    } {
      const t = e.variants.reduce((e, t) => {
        var {
          option1: t,
          option2: s,
          option3: i
        } = t;
        return t && e.option1.push({
          value: this._formatOptionLabel(t),
          exists: !0,
          available: !0
        }), s && e.option2.push({
          value: this._formatOptionLabel(s),
          exists: !0,
          available: !0
        }), i && e.option3.push({
          value: this._formatOptionLabel(i),
          exists: !0,
          available: !0
        }), e
      }, {
        option1: [],
        option2: [],
        option3: []
      });
      return Object.keys(t).forEach(e => {
        t[e] = [...new Map(t[e].map(e => [e.value, e])).values()]
      }), t
    }
  }
  _refreshValuesUI(e) {
    for (const o in e)
      for (const n of e[o]) {
        var t, {
          value: s,
          exists: i,
          available: r
        } = n,
          s = this.querySelector(`[data-index="${o}"][value="${s}"]`),
          a = !r && i;
        s && ((t = s.parentNode.querySelector("[js-availability-label]")) && (t.textContent = a ? this.availabilityLabels.outOfStock : this.availabilityLabels.available), s.classList.remove("sold-out"), s.classList.remove("notify-in-stock"), i ? a ? s.classList.add("notify-in-stock", a) : s.classList.toggle("sold-out", !r) : s.classList.add("sold-out"))
      }
  }
  _updateHistoryState(t) {
    if (history.replaceState) {
      let e;
      e = t ? window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id : window.location.protocol + "//" + window.location.host + window.location.pathname, window.history.replaceState({
        path: e
      }, "", e)
    }
  }
  _updateMasterSelect(e) {
    e && (this._masterSelect.value = e.id)
  }
  async _fetchProduct(e) {
    this.dispatchEvent(new CustomEvent(this._events.fetchBefore, {
      bubbles: !0
    }));
    try {
      var t = await (await fetch(`/products/${e}.js`)).json();
      return this.dispatchEvent(new CustomEvent(this._events.fetchAfter, {
        bubbles: !0
      })), t
    } catch (e) {
      this.dispatchEvent(new CustomEvent(this._events.fetchError, {
        details: {
          error: e
        },
        bubbles: !0
      }))
    }
  }
  _getDifference(e, t) {
    var s = {};
    if (e || t) {
      if (!e) return t;
      if (!t) return e;
      for (const i in t) t[i] !== e[i] && (s[i] = t[i])
    }
    return s
  }
  disconnectedCallback() {
    this._optionSelectors.forEach(e => e.removeEventListener("change", this._handleOptionChange))
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      bubbles: !0
    }), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onButtonClick.bind(this)))
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    "plus" === e.currentTarget.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
  }
}
class LoadingSpinner extends HTMLElement {
  constructor() {
    super();
    var e = document.createElement("template");
    e.innerHTML = `
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `, this.attachShadow({
      mode: "open"
    }), this.shadowRoot.appendChild(e.content.cloneNode(!0))
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super(), this.predictiveSearchDrawer = document.querySelector("#PredictiveSearchDrawer"), this.mobileInput = this.querySelector('input[type="search"]'), this.desktopInput = document.querySelector("#DesktopSearch"), this.inputs = [this.mobileInput, this.desktopInput], this.desktopInputWrapper = this.desktopInput.closest("[js-desktop-search-wrapper]"), this.predictiveSearchResults = this.querySelector("[js-predictive-search-results]"), this.popularSearches = this.querySelector("[js-predictive-search-popular-searches]"), this.clearSearchBtn = this.querySelector("[js-predictive-clear-search-btn]"), this.predictiveSearchDrawer.addEventListener("open", () => {
      this.inputs.forEach(e => {
        e.focus()
      })
    }), this.predictiveSearchDrawer.addEventListener("close", this.drawerClosed), this.clearSearchBtn.addEventListener("click", this.clearSearch), this.desktopInput.addEventListener("focus", this.desktopInputFocused), this.inputs.forEach(e => {
      e.addEventListener("input", theme.utils.debounce(e => {
        this.onChange(e)
      }, 300).bind(this))
    })
  }
  drawerClosed = () => {
    this.clearSearch(), this.desktopInputWrapper.classList.remove("focused")
  };
  desktopInputFocused = () => {
    this.predictiveSearchDrawer.classList.contains("open") || (this.desktopInputWrapper.classList.add("focused"), this.predictiveSearchDrawer.open())
  };
  clearSearch = () => {
    this.inputs.forEach(e => {
      e.value = ""
    });
    var e = new Event("input", {
      bubbles: !0,
      cancelable: !0
    });
    this.mobileInput.dispatchEvent(e)
  };
  onChange(e) {
    e = e.target.value.trim();
    e.length ? (this.clearSearchBtn.classList.remove("hidden"), this.getSearchResults(e)) : (this.clearSearchBtn.classList.add("hidden"), this.close())
  }
  getSearchResults(e) {
    fetch(routes.predictive_search_url + `?q=${e}&resources[type]=product,collection,article,page&resources[limit]=20&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku&section_id=predictive-search`).then(e => {
      if (e.ok) return e.text();
      throw e = new Error(e.status), this.close(), e
    }).then(e => {
      e = (new DOMParser).parseFromString(e, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.predictiveSearchResults.innerHTML = e, this.open()
    }).catch(e => {
      throw this.close(), e
    })
  }
  open() {
    this.predictiveSearchResults.style.display = "block", this.popularSearches.style.display = "none"
  }
  close() {
    this.predictiveSearchResults.style.display = "none", this.popularSearches.style.display = "block"
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      container: "filter-sort",
      form: "[js-filter-form]",
      filter: "[js-filter]",
      clearAll: "[js-clear-all]",
      loader: "loading-spinner"
    }, this._events = {
      change: "filter:change"
    }, this._refresh = ["[js-filter]", "[js-sort]", "[js-filter-results-count]"], document.querySelector("s-search") && this._refresh.pop(), this._cache = [], this._debouncedOnSubmit = theme.utils.debounce(e => {
      this._onSubmitHandler(e)
    }, 1000)
  }
  connectedCallback() {
    if (this._scope = this.dataset.scope, this._form = this.querySelector(this._selectors.form), this._clearAll = this.querySelector(this._selectors.clearAll), this._loader = this.querySelector(this._selectors.loader), this._setListeners(), !this._scope) throw new Error("filter-sort must have scope set. See filter-sort.liquid for docs.")
  }
  _setListeners() {
    window.addEventListener("popstate", this._onHistoryChange), this._form.addEventListener("input", this._debouncedOnSubmit), this._clearAll.addEventListener("click", this._onClearAllHandler), document.addEventListener("filter:change", this._onFilterChange), document.addEventListener("filter:clearAll", this._onClearAllHandler)
  }
  _renderComponent(e) {
    e = e.querySelector(`${this._selectors.container}[data-scope="${this._scope}"]`) || e.querySelector(this._selectors.container);
    theme.utils.refreshElements(this._refresh, e, this), this.querySelectorAll("s-accordion").forEach(e => {
      e.connectedCallback()
    })
  }
  _onSubmitHandler = e => {
    e.preventDefault();
    const formData = new FormData(this._form);  
    let minRaw = formData.get("filter.v.price.gte");
    let maxRaw = formData.get("filter.v.price.lte");  
    let minInput = this._form.querySelector('[name="filter.v.price.gte"]');
    let maxInput = this._form.querySelector('[name="filter.v.price.lte"]'); 
    let min = minRaw !== "" ? Number(minRaw) : null;
    let max = maxRaw !== "" ? Number(maxRaw) : null;  
    if (minInput && min !== null) {
      const minAttr = minInput.hasAttribute("min") ? Number(minInput.min) : -Infinity;
      const maxAttr = minInput.hasAttribute("max") ? Number(minInput.max) : Infinity; 
      if (min < minAttr) min = minAttr;
      if (min > maxAttr) min = maxAttr; 
      minInput.value = min;
      formData.set("filter.v.price.gte", min);
    } 
    if (maxInput && max !== null) {
      const minAttr = maxInput.hasAttribute("min") ? Number(maxInput.min) : -Infinity;
      const maxAttr = maxInput.hasAttribute("max") ? Number(maxInput.max) : Infinity; 
      if (max < minAttr) max = minAttr;
      if (max > maxAttr) max = maxAttr; 
      maxInput.value = max;
      formData.set("filter.v.price.lte", max);
    } 
    if (minInput && maxInput) {
      if (max !== null) { minInput.setAttribute("max", max); } 
      if (min !== null) { maxInput.setAttribute("min", min); } 
      if (min === null) { maxInput.setAttribute("min", 0); } 
      if (max === null) { maxInput.setAttribute("max", maxInput.getAttribute("max")); }
    } 
    if (min !== null && max !== null && min > max) {
      max = min;
      if (maxInput) maxInput.value = max; 
      formData.set("filter.v.price.lte", max);
    } 
    const params = new URLSearchParams(formData).toString();
    this._propagateChange(params);
  };
  _onClearAllHandler = e => {
    e.preventDefault();
    let t = "";
    e = document.querySelector("s-search");
    e && e.dataset.term && (t = "q=" + e.dataset.term), this._propagateChange(t)
  };
  _onFilterChange = e => {
    var {
      parsedHTML: e,
      scope: t
    } = e.detail;
    t !== this._scope && this._renderComponent(e)
  };
  _onHistoryChange = e => {
    e = e.state ? e.state.searchParams : FilterSort.searchParamsInitial;
    e !== FilterSort.searchParamsPrev && (this._propagateChange(e, !1), this._onSubmitHandlerEvent = null)
  };
  async _propagateChange(e, t = !0) {
    this._loader.setAttribute("loading", "");
    const s = window.location.pathname + "?" + e;
    var i = e => e.url === s,
      i = this._cache.some(i) ? this._markupFromCache(i) : await this._markupFromFetch(s);
    document.dispatchEvent(new CustomEvent("filter:change", {
      detail: {
        parsedHTML: i,
        scope: this._scope
      }
    })), this._renderComponent(i), t && history.pushState({
      searchParams: e
    }, "", "" + window.location.pathname + (e && "?".concat(e))), this._loader.removeAttribute("loading", "")
  }
  _markupFromCache(e) {
    e = this._cache.find(e).html;
    return (new DOMParser).parseFromString(e, "text/html")
  }
  _markupFromFetch(s) {
    let i = this._cache;
    return fetch(s).then(e => e.text()).then(e => {
      var t = (new DOMParser).parseFromString(e, "text/html");
      return i = [...i, {
        html: e,
        url: s
      }], t
    })
  }
}
FilterSort.searchParamsInitial = window.location.search.slice(1), FilterSort.searchParamsPrev = window.location.search.slice(1);
class ActiveFilters extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      remove: "[js-remove]",
      clearAll: "[js-clear-all]"
    }, this._refresh = ["[js-active-filter]"]
  }
  connectedCallback() {
    document.addEventListener("filter:change", this._handleFilterChange), this._setListeners()
  }
  _setListeners() {
    var e = this.querySelector(this._selectors.clearAll);
    e && e.addEventListener("click", this._triggerClearAll), this.querySelectorAll(this._selectors.remove).forEach(e => e.addEventListener("click", this._handleRemove))
  }
  _handleRemove = e => {
    e.preventDefault();
    var {
      name: e,
      value: t
    } = e.currentTarget.dataset, e = document.querySelector(`filter-sort [name="${e}"][value="${t}"]`);
    e && e.click()
  };
  _handleFilterChange = e => {
    e = e.detail.parsedHTML, e = e.querySelector("active-filters");
    if (!e) {
    this.innerHTML = "";
    return;
  }
    this.innerHTML = e.innerHTML, this._setListeners()
  };
  _triggerClearAll = e => {
    e.preventDefault(), e.stopImmediatePropagation(), document.dispatchEvent(new CustomEvent("filter:clearAll"))
  }
}
class PriceRange extends HTMLElement {
  constructor() {
    super(), this.querySelectorAll("input").forEach(e => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues()
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues()
  }
  setMinAndMaxValues() {
    var e = this.querySelectorAll("input"),
      t = e[0],
      e = e[1];
    e.value && t.setAttribute("max", e.value), t.value && e.setAttribute("min", t.value), "" === t.value && e.setAttribute("min", 0), "" === e.value && t.setAttribute("max", e.getAttribute("max"))
  }
  adjustToValidValues(e) {
    var t = Number(e.value),
      s = Number(e.getAttribute("min")),
      i = Number(e.getAttribute("max"));
    t < s && (e.value = s), i < t && (e.value = i)
  }
}
class MobileMenu extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      mobileMenuTrigger: "[js-mobile-menu-trigger]",
      mobileMenu: "[js-mobile-menu]",
      mobileMenuBackBtn: "[js-mobile-menu-back-btn]"
    }
  }
  connectedCallback() {
    this.mobileMenuTriggers = this.querySelectorAll(this._selectors.mobileMenuTrigger), this.mobileMenuBackBtn = this.querySelector(this._selectors.mobileMenuBackBtn), this.mobileMenuTriggers.forEach(e => {
      e.addEventListener("click", this._mobileMenuTriggerOnClick)
    }), this.mobileMenuBackBtn.addEventListener("click", this._backToMainNav)
  }
  _mobileMenuTriggerOnClick = e => {
    e.preventDefault(), e.currentTarget.nextElementSibling.dataset.active = "true", this.dataset.active = "true"
  };
  _backToMainNav = e => {
    e.preventDefault(), this.querySelector(this._selectors.mobileMenu + '[data-active="true"]').dataset.active = "false", this.dataset.active = "false"
  }
}
class MasonryGrid extends HTMLElement {
  constructor() {
    super(), this.options = {
      itemSelector: "[js-masonry-grid-item]"
    }
  }
  connectedCallback() {
    var e = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    this.options = Object.assign(this.options, e), this._initMasonry()
  }
  _initMasonry() {
    new Masonry(this, this.options)
  }
}
class ShowMore extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      showMoreBtn: "[js-show-more]",
      showMoreContainer: "[js-show-more-container]",
      showMoreArticle: "[js-show-more-article]",
      showCount: "[js-show-count]"
    }, this._handleShowMoreClick = this._handleShowMoreClick.bind(this)
  }
  connectedCallback() {
    this.showMoreBtn = this.querySelector(this._selectors.showMoreBtn), this.showMoreContainer = this.querySelector(this._selectors.showMoreContainer), this.showCount = this.querySelector(this._selectors.showCount), this._updateCount(), this._setListeners()
  }
  _setListeners() {
    this.showMoreBtn && this.showMoreBtn.addEventListener("click", this._handleShowMoreClick)
  }
  _handleShowMoreClick(e) {
    e.preventDefault();
    (async () => {
      var e = this.showMoreBtn.getAttribute("href"),
        e = await this._getMoreArticle(e),
        t = e.querySelectorAll(this._selectors.showMoreArticle),
        e = e.querySelector(this._selectors.showMoreBtn),
        e = e ? e.getAttribute("href") : null;
      this._handleAddingToDom({
        showMoreArticleArray: t,
        newURL: e
      })
    })()
  }
  _getMoreArticle = e => {
    return fetch(e).then(e => e.text()).then(e => {
      return (new DOMParser).parseFromString(e, "text/html")
    })
  };
  _handleAddingToDom(e) {
    var {
      newURL: e,
      showMoreArticleArray: t
    } = e;
    if (t)
      for (let e = 0; e < t.length; e++) this.showMoreContainer.appendChild(t[e]);
    e ? this.showMoreBtn.setAttribute("href", e) : this.showMoreBtn.classList.add("hidden"), this._updateCount()
  }
  _updateCount() {
    var e = this.showCount.getAttribute("data-total-count"),
      t = this.querySelectorAll(this._selectors.showMoreArticle).length;
    this.showCount.textContent = `Showing ${t} of ${e} Stories`
  }
}
class RecentlyViewed extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      productCardsContainer: "[js-product-cards]"
    }
  }
  connectedCallback() {
    this._initModule()
  }
  _initModule() {
    this.currentHandle = this.getAttribute("data-handle"), this.viewedProducts = JSON.parse(sessionStorage.getItem("recentlyViewed")) || [], this.productCardsContainer = this.querySelector(this._selectors.productCardsContainer), 0 < this.viewedProducts.length && this._getMarkup(), this._updateSessionStorage()
  }
  _getMarkup = async () => {
    this.productCardsHTML = [];
    for (let e = 0; e < parseInt(this.dataset.limit); e++) {
      var t;
      this.viewedProducts[e] && (t = this.viewedProducts[e]) != this.currentHandle && (t = await this._getProductMarkup(t), this.productCardsHTML.push(t))
    }
    0 < this.productCardsHTML.length && this._renderMarkup()
  };
  _getProductMarkup = e => fetch(`/products/${e}?view=product-card`).then(e => e.text()).then(e => {
    return (new DOMParser).parseFromString(e, "text/html").querySelector("[js-product-card]")
  });
  _renderMarkup() {
    this.productCardsHTML.forEach(e => {
      e.setAttribute("js-carousel-slide", ""), e.classList.add("swiper-slide"), this.productCardsContainer.append(e)
    }), this.classList.add("block"), this.classList.remove("hidden")
  }
  _updateSessionStorage() {
    var e;
    this.currentHandle && (this.viewedProductsUpdate = [...new Set(this.viewedProducts)], this.viewedProductsUpdate.includes(this.currentHandle) && (e = this.viewedProductsUpdate.indexOf(this.currentHandle), this.viewedProductsUpdate.splice(e, 1)), this.viewedProductsUpdate.unshift(this.currentHandle), 7 < this.viewedProductsUpdate.length && this.viewedProductsUpdate.splice(-1), sessionStorage.setItem("recentlyViewed", JSON.stringify(this.viewedProductsUpdate)))
  }
}
class ProductCardUpsell extends HTMLElement {
  constructor() {
    super(), this.selectors = {
      quickAdd: "[js-quick-add]",
      quickAddPrice: "[js-quick-add-price]",
      optionSelectorDesktop: "[js-option-selector-desktop]",
      productJson: "#ProductJSON",
      imageContainer: "[js-image-container]",
      price: "[js-price]",
      discountPrice: "[js-discount-price]",
      mobileSelectorContainer: "[js-mobile-selector-container]",
      mobileDrewer: "#UpsellMobileDrawer",
      mobileOption: "[js-mobile-option]",
      mobileOptionCheckmark: "[js-checkmark]",
      upsellModal: "#ProductUpsellModal"
    }
  }
  connectedCallback() {
    this.quickAdd = this.querySelectorAll(this.selectors.quickAdd), this.optionSelectorDesktop = this.querySelector(this.selectors.optionSelectorDesktop), this.productJson = JSON.parse(this.querySelector(this.selectors.productJson).textContent), this.imageContainer = this.querySelector(this.selectors.imageContainer), this.price = this.querySelector(this.selectors.price), this.discountPrice = this.querySelector(this.selectors.discountPrice), this.mobileSelectorContainer = this.querySelector(this.selectors.mobileSelectorContainer), this.mobileDrewer = document.querySelector(this.selectors.mobileDrewer), this.discountPercentage = this.dataset.discountPercentage, this.cart = document.querySelector("cart-drawer"), this.cartDrawer = document.querySelector("#CartDrawer"), this._initMobileDrewer(), this._initQuickAdd(), this._updateDiscountPrice()
  }
  _initMobileDrewer() {
    this.mobileSelectorContainer && this.mobileSelectorContainer.querySelectorAll(this.selectors.mobileOption).forEach(e => {
      e.addEventListener("click", this._handleMobileOptionClick.bind(this))
    })
  }
  _initQuickAdd() {
    null != this.quickAdd && this.quickAdd.forEach(e => {
      e.addEventListener("click", this._submitSingle.bind(this))
    }), null != this.optionSelectorDesktop && (this.optionSelectorDesktop.addEventListener("click", this._handleChoiceClick.bind(this)), this.optionSelectorDesktop.addEventListener("change", this._handleChoiceChange.bind(this)))
  }
  _handleMobileOptionClick(e) {
    var e = e.currentTarget,
      t = e.querySelector(this.selectors.mobileOptionCheckmark);
    const s = e.dataset.variantId;
    null != this.quickAdd && this.quickAdd.forEach(e => {
      e.setAttribute("data-variant-id", s)
    }), this._updateImageSrc(Number(s)), this._updateDiscountPrice(Number(s)), this.optionSelectorDesktop.choices.setChoiceByValue(s), this.mobileSelectorContainer.querySelectorAll(this.selectors.mobileOption).forEach(e => {
      var t = e.querySelector(this.selectors.mobileOptionCheckmark);
      e.classList.remove("selected"), t.classList.contains("hidden") || t.classList.add("hidden")
    }), t.classList.remove("hidden"), e.classList.add("selected")
  }
  _handleChoiceChange(e) {
    const t = Number(e.target.querySelector("option").value);
    null != this.quickAdd && this.quickAdd.forEach(e => {
      e.setAttribute("data-variant-id", t)
    }), this._updateImageSrc(t), this._updateDiscountPrice(t)
  }
  _updateDiscountPrice(e) {
    let t;
    t = e || this.dataset.variantId;
    let s;
    for (let e = 0; e < this.productJson.variants.length; e++) t == this.productJson.variants[e].id && (s = this.productJson.variants[e]);
    var i, r;
    this.discountPrice && this.price && this.discountPercentage && s && (i = ((e = s.price) * (1 - Number(this.discountPercentage) / 100) * .01).toFixed(2), e = (.01 * e).toFixed(2), r = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }), this.discountPrice && (this.discountPrice.textContent = r.format(i)), this.price.textContent = r.format(e))
  }
  _updateImageSrc(t) {
    let s;
    for (let e = 0; e < this.productJson.variants.length; e++) t == this.productJson.variants[e].id && (s = this.productJson.variants[e]);
    s && (this.imageContainer.querySelector("img").src = s.featured_image.src)
  }
  _handleChoiceClick(e) {
    if (768 < (document.documentElement.clientWidth || window.innerWidth)) {
      const s = e.target.dataset.value;
      this.optionSelectorDesktop.choices.dropdown.isActive ? this.optionSelectorDesktop.choices.hideDropdown() : this.optionSelectorDesktop.choices.showDropdown(), this.optionSelectorDesktop.choices.setChoiceByValue(s), null != this.quickAdd && this.quickAdd.forEach(e => {
        e.setAttribute("data-variant-id", Number(s))
      }), this._updateImageSrc(Number(s)), this._updateDiscountPrice(Number(s))
    } else {
      document.querySelector(this.selectors.mobileDrewer).open();
      for (var t = this.mobileDrewer.querySelector("[js-upsell-options-container]"); t.firstChild;) t.removeChild(t.lastChild);
      t.appendChild(this.mobileSelectorContainer)
    }
  }
  _submitSingle(e) {
    e.preventDefault();
    e = e.target.dataset.variantId, this.cart.setActiveElement(document.activeElement), e = {
      items: [{
        id: e,
        quantity: 1
      }],
      sections: this.cart.getSectionsToRender().map(e => e.id)
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(e)
    }).then(e => e.json()).then(e => {
      this.cart.renderContents(e), this.cartDrawer.open()
    }).catch(e => {
      console.error("Error:", e)
    })
  }
}
class ChoicesSelect extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      selectDropdown: "select"
    }, this.options = {
      searchEnabled: !1,
      shouldSort: !1,
      allowHTML: !0,
      placeholder: !1,
      itemSelectText: ""
    }
  }
  connectedCallback() {
    var e = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    this.options = Object.assign(this.options, e), this._initFakeDropdown()
  }
  _initFakeDropdown() {
    var e = this.querySelector(this._selectors.selectDropdown),
      e = new Choices(e, this.options);
    this.choices = e
  }
}
class RecipientForm extends HTMLElement {
  constructor() {
    super(), this.recipientFieldsLiveRegion = this.querySelector("#Recipient-fields-live-region-" + this.dataset.sectionId), this.checkboxInput = this.querySelector("#Recipient-checkbox-" + this.dataset.sectionId), this.checkboxInput.disabled = !1, this.hiddenControlField = this.querySelector("#Recipient-control-" + this.dataset.sectionId), this.hiddenControlField.disabled = !0, this.emailInput = this.querySelector("#Recipient-email-" + this.dataset.sectionId), this.nameInput = this.querySelector("#Recipient-name-" + this.dataset.sectionId), this.messageInput = this.querySelector("#Recipient-message-" + this.dataset.sectionId), this.sendonInput = this.querySelector("#Recipient-send-on-" + this.dataset.sectionId), this.offsetProperty = this.querySelector("#Recipient-timezone-offset-" + this.dataset.sectionId), this.offsetProperty && (this.offsetProperty.value = (new Date).getTimezoneOffset().toString()), this.errorMessageWrapper = this.querySelector(".product-form__recipient-error-message-wrapper"), this.errorMessageList = this.errorMessageWrapper?.querySelector("ul"), this.errorMessage = this.errorMessageWrapper?.querySelector(".error-message"), this.defaultErrorHeader = this.errorMessage?.innerText, this.currentProductVariantId = this.dataset.productVariantId, this.addEventListener("change", this.onChange.bind(this)), this.onChange()
  }
  cartUpdateUnsubscriber = void 0;
  variantChangeUnsubscriber = void 0;
  cartErrorUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, e => {
      "product-form" === e.source && e.productVariantId.toString() === this.currentProductVariantId && this.resetRecipientForm()
    }), this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, e => {
      e.data.sectionId === this.dataset.sectionId && (this.currentProductVariantId = e.data.variant.id.toString())
    }), this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, e => {
      "product-form" === e.source && e.productVariantId.toString() === this.currentProductVariantId && this.displayErrorMessage(e.message, e.errors)
    })
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber(), this.cartErrorUnsubscriber && this.cartErrorUnsubscriber()
  }
  onChange() {
    this.checkboxInput.checked ? this.enableInputFields() : (this.clearInputFields(), this.disableInputFields(), this.clearErrorMessage())
  }
  inputFields() {
    return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput]
  }
  disableableFields() {
    return [...this.inputFields(), this.offsetProperty]
  }
  clearInputFields() {
    this.inputFields().forEach(e => e.value = "")
  }
  enableInputFields() {
    this.disableableFields().forEach(e => e.disabled = !1)
  }
  disableInputFields() {
    this.disableableFields().forEach(e => e.disabled = !0)
  }
  displayErrorMessage(e, t) {
    if (this.clearErrorMessage(), this.errorMessageWrapper.hidden = !1, "object" == typeof t) return this.errorMessage.innerText = this.defaultErrorHeader, Object.entries(t).forEach(([e, t]) => {
      var s = `RecipientForm-${e}-error-` + this.dataset.sectionId,
        i = `#Recipient-${e}-` + this.dataset.sectionId,
        t = "" + t.join(", "),
        r = this.querySelector("#" + s),
        a = r?.querySelector(".error-message");
      a && (this.errorMessageList && this.errorMessageList.appendChild(this.createErrorListItem(i, t)), a.innerText = t + ".", r.classList.remove("hidden"), i = this[e + "Input"]) && (i.setAttribute("aria-invalid", !0), i.setAttribute("aria-describedby", s))
    });
    this.errorMessage.innerText = t
  }
  createErrorListItem(e, t) {
    var s = document.createElement("li"),
      i = document.createElement("a");
    return i.setAttribute("href", e), i.innerText = t, s.appendChild(i), s.className = "error-message", s
  }
  clearErrorMessage() {
    this.errorMessageWrapper.hidden = !0, this.errorMessageList && (this.errorMessageList.innerHTML = ""), this.querySelectorAll(".recipient-fields .form__message").forEach(e => {
      e.classList.add("hidden");
      e = e.querySelector(".error-message");
      e && (e.innerText = "")
    }), [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach(e => {
      e.setAttribute("aria-invalid", !1), e.removeAttribute("aria-describedby")
    })
  }
  resetRecipientForm() {
    this.checkboxInput.checked && (this.checkboxInput.checked = !1, this.clearInputFields(), this.clearErrorMessage())
  }
}
class ReadMore extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      readMoreBtn: "[js-read-more-btn]",
      readMoreContainer: "[js-read-more-container]",
      backgroundOverlay: "[js-background-overlay]"
    }, this._handleReadMoreClick = this._handleReadMoreClick.bind(this)
  }
  connectedCallback() {
    this.readMoreBtn = this.querySelector(this._selectors.readMoreBtn), this.readMoreContainer = this.querySelector(this._selectors.readMoreContainer), this.backgroundOverlay = this.querySelector(this._selectors.backgroundOverlay), this._setListeners()
  }
  _setListeners() {
    this.readMoreBtn && this.readMoreBtn.addEventListener("click", this._handleReadMoreClick)
  }
  _handleReadMoreClick(e) {
    e.preventDefault(), this.readMoreBtn.classList.add("hidden"), this.backgroundOverlay.classList.add("hidden"), this.readMoreContainer.style = ""
  }
}
class ProductCard extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      swatchItem: "[js-product-color-swatch-item]",
      productCardImageList: "[js-product-card-image]",
      productCardLink: "[js-product-card-link]"
    }
  }
  connectedCallback() {
    this.swatchItems = this.querySelectorAll(this._selectors.swatchItem), this.productCardImageList = this.querySelectorAll(this._selectors.productCardImageList), this.productCardLink = this.querySelectorAll(this._selectors.productCardLink), this.swatchItems.forEach(e => {
      e.addEventListener("click", this._handleSwatchItemClick.bind(this))
    })
  }
  _handleSwatchItemClick(t) {
    this.swatchItems.forEach(e => {
      e.classList.remove("selected")
    }), t.currentTarget.classList.add("selected"), this.productCardImageList.forEach(e => {
      e.dataset.variantId === t.currentTarget.dataset.variantId ? e.classList.remove("hidden") : e.classList.add("hidden")
    }), this.productCardLink.forEach(e => {
      e.href = t.currentTarget.dataset.variantUrl
    })
  }
}
class KlaviyoBis extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      form: "[js-klaviyo-bis-form]",
      email: "[js-klaviyo-bis-email]",
      submit: "[js-klaviyo-bis-submit]",
      loader: "[js-klaviyo-bis-loader]",
      message: "[js-klaviyo-bis-message]",
      submitText: ".klaviyo-bis__submit-text",
      success: "[js-klaviyo-bis-success]",
      newsletterCheckbox: 'input[name="subscribe"]'
    }, this.companyId = "VFMztw"
  }
  connectedCallback() {
    console.log("KlaviyoBis connected"), this.form = this.querySelector(this._selectors.form), this.emailInput = this.querySelector(this._selectors.email), this.submitBtn = this.querySelector(this._selectors.submit), this.loader = this.querySelector(this._selectors.loader), this.message = this.querySelector(this._selectors.message), this.submitText = this.querySelector(this._selectors.submitText), this.success = this.querySelector(this._selectors.success), this.newsletterCheckbox = this.querySelector(this._selectors.newsletterCheckbox), this._updateVariantId(), this._bindEvents()
  }
  _updateVariantId() {
    var e = this.dataset.variantId || "";
    this.variantId = e ? "$shopify:::$default:::" + e : "", console.log("KlaviyoBis variant ID updated:", this.variantId)
  }
  updateVariantId(e) {
    this.dataset.variantId = e, this._updateVariantId()
  }
  _bindEvents() {
    this.form?.addEventListener("submit", this._handleSubmit.bind(this))
  }
  _handleSubmit(e) {
    e.preventDefault();
    var e = this.emailInput?.value?.trim(),
      t = this.newsletterCheckbox?.checked || !1;
    e && this._isValidEmail(e) ? (this._setLoading(!0), this._submitToKlaviyo(e, t)) : this._showMessage("Please enter a valid email address.", "error")
  }
  _isValidEmail(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
  }
  _submitToKlaviyo(t, s) {
    var e = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: t
              }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: this.variantId
            }
          }
        }
      }
    };
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + this.companyId, {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        revision: "2024-02-15",
        "x-klaviyo-onsite": "1"
      },
      body: JSON.stringify(e),
      mode: "cors",
      credentials: "omit"
    }).then(e => {
      if (!e.ok) throw new Error("Network response was not ok");
      this.submitBtn.style.display = "none", this.success.style.display = "block", s && this._subscribeToNewsletter(t)
    }).catch(e => {
      console.error("Klaviyo BIS error:", e), this._showMessage("Something went wrong. Please try again.", "error")
    }).finally(() => {
      this._setLoading(!1)
    })
  }
  _setLoading(e) {
    e ? (this.submitBtn?.setAttribute("disabled", ""), this.loader?.classList.remove("hidden"), this.submitText?.classList.add("hidden")) : (this.submitBtn?.removeAttribute("disabled"), this.loader?.classList.add("hidden"), this.submitText?.classList.remove("hidden"))
  }
  _showMessage(e) {
    this.message && (this.message.textContent = e, this.message.classList.remove("hidden"))
  }
  _subscribeToNewsletter(e) {
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + this.companyId, {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        revision: "2024-02-15",
        "x-klaviyo-onsite": "1"
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: e,
                  properties: {
                    $source: "Back in Stock"
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "SRwALh"
              }
            }
          }
        }
      }),
      mode: "cors",
      credentials: "omit"
    }).then(e => {
      e.ok ? console.log("Newsletter subscription successful") : console.error("Newsletter subscription failed")
    }).catch(e => {
      console.error("Newsletter subscription error:", e)
    })
  }
}
class KlaviyoBisTrigger extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector("button")
  }
  connectedCallback() {
    this.button && this.button.addEventListener("click", this._handleClick.bind(this))
  }
  _handleClick(e) {
    var t = document.querySelector("#KlaviyoBisModal"),
      s = t?.querySelector("klaviyo-bis"),
      i = document.getElementById("klaviyo-product-title"),
      t = t?.querySelector("[js-klaviyo-bis-select]");
    s && s.updateVariantId(this.dataset.variantId), i && (i.textContent = this.dataset.productTitle), t && (t.options[0].textContent = this.dataset.productVariantOption, t.options[0].value = this.dataset.productVariantOption, t.value = this.dataset.productVariantOption)
  }
}
class ScrollableTables extends HTMLElement {
  constructor() {
    super(), this.tables = this.querySelectorAll("table"), this.wrapTable = this.wrapTable.bind(this)
  }
  connectedCallback() {
    this.tables.forEach(e => this.wrapTable(e))
  }
  wrapTable(e) {
    var t = document.createElement("div"),
      s = (t.className = "table-wrapper table-wrapper--scroll", document.createElement("div"));
    s.className = "table-wrapper__content", e.parentNode.insertBefore(t, e), s.appendChild(e), t.appendChild(s)
  }
}
customElements.define("s-drawer", Drawer), customElements.define("s-modal", Modal), customElements.define("s-accordion", Accordion), customElements.define("s-tabs", Tabs), customElements.define("s-carousel", Carousel), customElements.define("video-player", VideoPlayer), customElements.define("cart-remove-button", CartRemoveButton), customElements.define("cart-items", CartItems), customElements.define("cart-note", CartNote), customElements.define("cart-drawer", CartDrawer), customElements.define("cart-drawer-items", CartDrawerItems), customElements.define("s-header", SiteHeader), customElements.define("product-options", ProductOptions), customElements.define("quantity-input", QuantityInput), customElements.define("loading-spinner", LoadingSpinner), customElements.define("predictive-search", PredictiveSearch), customElements.define("filter-sort", FilterSort), customElements.define("active-filters", ActiveFilters), customElements.define("price-range", PriceRange), customElements.define("mobile-menu", MobileMenu), customElements.define("masonry-grid", MasonryGrid), customElements.define("show-more", ShowMore), customElements.define("recently-viewed", RecentlyViewed), customElements.define("product-card-upsell", ProductCardUpsell), customElements.define("s-choices", ChoicesSelect), customElements.define("recipient-form", RecipientForm), customElements.define("read-more", ReadMore), customElements.define("product-card", ProductCard), customElements.define("klaviyo-bis", KlaviyoBis), customElements.define("klaviyo-bis-trigger", KlaviyoBisTrigger), customElements.define("scrollable-tables", ScrollableTables);
class CollectionGrid extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      collectionGrid: "[js-collection-grid]",
      toggleView: "[js-collection-toggle-view]",
      sortTrigger: "[js-collection-sort-trigger]",
      paginationText: "[js-collection-pagination-text]",
      loadMore: "[js-collection-load-more]",
      nextPage: "[js-next-page]",
      loader: "loading-spinner",
      filterSort: "[js-filter-sort]",
      filterBtn: "[js-filter-btn]",
      filterBtnText: "[js-filter-btn-text]",
      filterDesktop: "[js-filter-desktop]"
    }, this._refresh = ["[js-collection-grid]", "[js-collection-products-count]", "[js-collection-sort-trigger]", "[js-collection-pagination]", "[js-filter-count]"], this._cache = []
  }
  connectedCallback() {
    this.collectionGrid = this.querySelector(this._selectors.collectionGrid), this.toggleViews = this.querySelectorAll(this._selectors.toggleView), this.sortTrigger = this.querySelector(this._selectors.sortTrigger), this.paginationText = this.querySelector(this._selectors.paginationText), this.loadMore = this.querySelector(this._selectors.loadMore), this.loader = this.querySelector(this._selectors.loader), this._setListeners(), this._retainHistory(), this._initInfiniteScroll()
  }
  _setListeners() {
    document.addEventListener("filter:change", this._handleFilterChange), this.toggleViews.forEach(e => {
      e.addEventListener("click", this._updateView)
    }), this.sortTrigger && this.sortTrigger.addEventListener("change", this._handleSortTrigger), this.loadMore && this.loadMore.addEventListener("click", this._loadMoreProducts), document.querySelector(this._selectors.filterBtn).addEventListener("click", this._toggleFilterMenu)
  }
  _handleSortTrigger = e => {
    e.preventDefault();
    e = document.querySelector("[js-filter-form] [js-sort]").querySelector(`input[value="${e.currentTarget.value}"]`);
    e && e.click()
  };
  _retainHistory() {
    this.isFilterChanged || history.state && (history.state.products && (this.collectionGrid.innerHTML = history.state.products), history.state.view) && (this.collectionGrid.setAttribute("data-view", history.state.view), this.toggleViews.forEach(e => {
      e.removeAttribute("disabled")
    }), this.querySelector(`${this._selectors.toggleView}[data-view=${history.state.view}]`).setAttribute("disabled", ""))
  }
  _updateHistory(e, t, s) {
    let i = {};
    (i = history.state ? history.state : i)[e] = t, s ? history.pushState(i, "", s) : history.pushState(i, "")
  }
  _getProducts = e => {
    return fetch(e).then(e => e.text()).then(e => {
      return (new DOMParser).parseFromString(e, "text/html")
    })
  };
  _loadMoreProducts = () => {
    (async () => {
      this.loader.setAttribute("loading", "");
      var e = this.loadMore.dataset.url,
        t = await this._getProducts(e),
        s = t.querySelector(this._selectors.collectionGrid).innerHTML,
        i = t.querySelector(this._selectors.paginationText),
        t = t.querySelector(this._selectors.loadMore);
      this.collectionGrid.insertAdjacentHTML("beforeend", s), this.paginationText.textContent = i.textContent, this._updateHistory("products", this.collectionGrid.innerHTML, e), t ? (this.loadMore.setAttribute("data-url", t.dataset.url), this.loadMore.removeAttribute("js-next-page")) : this.loadMore.remove(), this.loader.removeAttribute("loading")
    })()
  };
  _updateView = e => {
    e.preventDefault();
    var e = e.currentTarget,
      t = e.dataset.view;
    this.toggleViews.forEach(e => {
      e.removeAttribute("disabled")
    }), e.setAttribute("disabled", ""), this.collectionGrid.setAttribute("data-view", t), this._updateHistory("view", t)
  };
  _handleFilterChange = e => {
    e = e.detail.parsedHTML, e = e.querySelector(`[data-id="${this.dataset.id}"]`);
    theme.utils.refreshElements(this._refresh, e, this), this.isFilterChanged = !0, this.connectedCallback()
  };
  _toggleFilterMenu = e => {
    var t = document.querySelector(this._selectors.filterBtn),
      s = t.querySelector(this._selectors.filterBtnText),
      i = this.querySelector(this._selectors.filterDesktop),
      r = this.querySelector(this._selectors.collectionGrid);
    0 == t.classList.contains("active") ? (r.classList.add("show-filters"), t.classList.add("active"), s.textContent = "絞り込み非表示", i.classList.add("active")) : (r.classList.remove("show-filters"), t.classList.remove("active"), s.textContent = "絞り込み表示", i.classList.remove("active"))
  };
  _initInfiniteScroll = () => {
    const t = this.querySelector(this._selectors.nextPage);
    if (!t) return;
    console.log(t.dataset.url), t && new IntersectionObserver(e => {
      e.forEach(e => {
        t.dataset.url.includes("page=2") && e.isIntersecting && this._loadMoreProducts(t)
      })
    }, {
      root: null,
      threshold: 1
    }).observe(t)
  }
}
class ProductMain extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      addToCart: "[js-add-to-cart]",
      price: "[js-price]",
      stickyBar: "[js-product-sticky-bar]",
      stickyAtc: "[js-sticky-atc]",
      stickySelectOptionsBtn: "[js-sticky-select-options]",
      imagesModal: "#ProductImagesModal",
      imagesModalTrigger: "[js-open-product-images-modal]",
      modalThumbImage: "[js-product-modal-thumbnail-image]",
      modalImagesScrollWrapper: "[js-product-modal-images-scroll]",
      modalMainImage: "[js-product-modal-main-image]",
      error: "[js-error-message]",
      form: "[js-product-form]",
      loader: "loading-spinner",
      stickyLoader: "[js-sticky-loader]",
      buyBoxSequence: "[js-product-buy-box-sequence]",
      variantsMetafields: "#ProductVariantsMetafields",
      variantNums: "[js-product-variant-nums]",
      currentColorLabel: "[js-product-current-color-label]",
      siblingsContainer: "[js-product-siblings]",
      productImagesCarousel: "[js-product-images]",
      productImage: "[js-product-image]",
      colorGroupTrigger: "[js-product-color-group-trigger]",
      colorSwatch: "[js-product-color-swatch]",
      colorSwatchContainer: "[js-product-color-swatch-container]",
      colorSwatchScrollGradient: "[js-product-color-swatch-scroll-gradient]",
      thumbnail: "[js-thumbnail]",
      swimBtn: "[open-product-video-modal]",
      videoModal: "#ProductVideoModal",
      swimVideo: "[js-swim-video]",
      productVideo: "[js-product-video]",
      productVideoExternal: "[js-product-video-external]",
      swiperNavContainer: "[js-swiper-nav-container]",
      saleColorLabel: "[js-product-current-sale-color-label]",
      quantityInput: "[js-quantity-input]",
      variantModalBtns: "[js-variant-tab-btn]",
      variantModalOptions: "[js-quick-view-options]",
      variantAtcBtns: "[js-variant-atc]",
      variantData: "[js-variant-data]",
      variantFilterButtons: "[js-find-tech]"
    }
  }
  connectedCallback() {
    this.addToCart = this.querySelector(this._selectors.addToCart), this.prices = this.querySelectorAll(this._selectors.price), this.buttons = [this.addToCart], this.loaders = [this.querySelector(this._selectors.loader)], this.buyBoxSequence = this.querySelector(this._selectors.buyBoxSequence), this.variantsMetafields = JSON.parse(this.querySelector(this._selectors.variantsMetafields).innerHTML), this.variantNums = this.querySelector(this._selectors.variantNums), this.numOptions = parseInt(this.dataset.numOptions), this.swiperThumbnails = this.querySelectorAll(this._selectors.thumbnail), this.swimBtn = this.querySelector(this._selectors.swimBtn), this.videoModal = this.querySelector(this._selectors.videoModal), this.productImagesCarousel = this.querySelector(this._selectors.productImagesCarousel), this.defaultVariantSelectionId = this.getAttribute("data-variant-id"), this.productVideos = this.querySelectorAll(this._selectors.productVideo), this.productVideosExternal = this.querySelectorAll(this._selectors.productVideoExternal), this.swiperNavContainer = this.querySelector(this._selectors.swiperNavContainer), this.quantityInput = this.querySelector(this._selectors.quantityInput), this.currentPrice = this.dataset.currentPrice, this.variantModalBtns = document.querySelectorAll(this._selectors.variantModalBtns), this.variantAtcBtns = document.querySelectorAll(this._selectors.variantAtcBtns), this.variantData = document.querySelectorAll(this._selectors.variantData), this.variantFilterButtons = document.querySelectorAll(this._selectors.variantFilterButtons), this.variantModal = document.querySelector("[js-variant-drawer]"), this.querySelector(this._selectors.swimVideo) && (this.swimVideo = this.querySelector(this._selectors.swimVideo).querySelector("video")), this.hasAttribute("data-color-option-position") && (this.colorOptionPosition = this.dataset.colorOptionPosition, this.currentColorLabel = this.querySelector(this._selectors.currentColorLabel), this.saleColorLabel = this.querySelector(this._selectors.saleColorLabel), this.colorSwatchContainer = this.querySelector(this._selectors.colorSwatchContainer), this.colorSwatchScrollGradient = this.querySelector(this._selectors.colorSwatchScrollGradient), this.colorSwatchScrollGradient) && (this._toggleColorSwatchScrollGrdient(), window.addEventListener("resize", this._toggleColorSwatchScrollGrdient), this._handleColorGroupping()), this.productImagesCarousel && this.productImagesCarousel.swiper.on("slideChange", this._handleThumbnailChange.bind(this)), this.swiperThumbnails && this.swiperThumbnails.forEach(e => e.addEventListener("click", this._handleThumnbnailClick.bind(this))), this.swimBtn && (this.videoModal.addEventListener("open", this._autoPlayVideo), this.videoModal.addEventListener("close", this._autoPlayVideo), document.addEventListener("fullscreenchange", this._closeVideo), "iPhone" == window.navigator.platform) && enquire.register(theme.config.mediaQueries.belowDesktop, {
      match: function () {
        this.swimVideo.addEventListener("webkitendfullscreen", this._closeVideo)
      }.bind(this)
    }), this.productVideos && (this._handleVideoElements(), this.productVideos.forEach(e => {
      e = e.querySelector("video");
      e.addEventListener("play", this._handleVideoPlay.bind(this)), e.addEventListener("pause", this._handleVideoPause.bind(this))
    })), this.variantModalBtns && this.variantModalBtns.forEach(e => {
      e.addEventListener("click", this._loadVariantTab)
    }), this.variantAtcBtns && this.variantAtcBtns.forEach(e => {
      e.addEventListener("click", this._addVariant)
    }), this.variantFilterButtons && this.variantFilterButtons.forEach(e => {
      e.addEventListener("click", this._filterSection)
    }), this.quantityInput.addEventListener("change", this._handleQuantityChange.bind(this)), this._updateFullWidthGridImage(), this.addEventListener("variant:change", this._handleVariantChange), this._initProductForm(), this._initProductSiblings(), this._handleStickyBar(), this._handleImagesModal()
  }
  _handleQuantityChange(s) {
    this.buttons.forEach(e => {
      var t;
      this.currentPrice && (t = s.target.value * Number(this.currentPrice), e.textContent = "Add To Cart - " + theme.utils.formatMoney(t, theme.config.money.format))
    })
  }
  _handleVideoPlay(e) {
    this.swiperNavContainer.classList.add("hidden")
  }
  _handleVideoPause(e) {
    this.swiperNavContainer.classList.remove("hidden")
  }
  _handleVideoElements = () => {
    if (!(this.productVideos.length < 1)) {
      const t = new IntersectionObserver((e, t) => {
        e.forEach(e => {
          var t;
          e.isIntersecting || (e = e.target.querySelector("video"), 0 < (t = e).currentTime && !t.paused && !t.ended && 2 < t.readyState && e.pause())
        })
      }, {
        threshold: .1
      });
      this.productVideos.forEach(e => {
        t.observe(e)
      })
    }
  };
  _autoPlayVideo = () => {
    this.swimVideo.paused ? this.swimVideo.play() : this.swimVideo.pause()
  };
  _closeVideo = () => {
    document.fullscreenElement || this.videoModal.close(), "iPhone" == window.navigator.platform && enquire.register(theme.config.mediaQueries.belowDesktop, {
      match: function () {
        this.swimVideo.webkitDisplayingFullscreen || this.videoModal.close()
      }.bind(this)
    })
  };
  _toggleColorSwatchScrollGrdient = () => {
    this.colorSwatchScrollGradient.classList.add("hidden"), this.colorSwatchContainer.offsetHeight < this.colorSwatchContainer.scrollHeight ? (this.colorSwatchScrollGradient.classList.remove("hidden"), this.colorSwatchScrollGradientHidden = !1) : this.colorSwatchScrollGradient.classList.add("hidden")
  };
  _handleColorGroupping = () => {
    this.colorGroupTriggers = this.querySelectorAll("product-options " + this._selectors.colorGroupTrigger), this.colorSwatches = this.querySelectorAll("product-options " + this._selectors.colorSwatch), this.colorGroupTriggers.forEach(e => {
      e.addEventListener("click", e => {
        this.querySelector(`product-options ${this._selectors.colorGroupTrigger}[disabled]`)?.removeAttribute("disabled"), e.currentTarget.setAttribute("disabled", "");
        const s = e.currentTarget.dataset.type;
        if ("all" == s) this.colorSwatches.forEach(e => {
          e.classList.remove("hidden")
        });
        else {
          let t = !1;
          this.colorSwatches.forEach(e => {
            e.dataset.colorType == s ? (e.classList.remove("hidden"), t || (e.querySelector("input").click(), t = !0)) : e.classList.add("hidden")
          })
        }
        this._toggleColorSwatchScrollGrdient()
      })
    });
    const r = () => {
      40 <= this.colorSwatchContainer.scrollHeight - this.colorSwatchContainer.offsetHeight - this.colorSwatchContainer.scrollTop && (this.colorSwatchScrollGradient.classList.remove("hidden"), this.colorSwatchScrollGradientHidden = !1, this.colorSwatchContainer.removeEventListener("scroll", r))
    };
    this.colorSwatches.forEach(i => {
      i.querySelector("[js-product-option-selector]").addEventListener("click", () => {
        var e = i.getBoundingClientRect().top,
          t = this.colorSwatchScrollGradient.getBoundingClientRect().top,
          s = this.colorSwatchContainer.scrollHeight - (i.offsetTop + 68);
        this.colorSwatchScrollGradientHidden && 60 <= s ? (this.colorSwatchScrollGradient.classList.remove("hidden"), this.colorSwatchScrollGradientHidden = !1) : 0 == this.colorSwatchScrollGradient.classList.contains("hidden") && t - e < 60 && (this.colorSwatchContainer.scrollTop += 60 - (t - e), s <= 60) && (this.colorSwatchScrollGradient.classList.add("hidden"), this.colorSwatchScrollGradientHidden = !0, this.colorSwatchContainer.addEventListener("scroll", r))
      })
    })
  };
  _stickyAtcOnClick = e => {
    e.preventDefault(), this.stickyAtcClicked = !0, this.addToCart.click()
  };
  _handleThumbnailChange = () => {
    var e = this.productImagesCarousel.swiper.activeIndex;
    const a = this.productImagesCarousel.swiper.slides[e];
    if (!a) return;
    const i = a.dataset.imageName.replace(".jpg", "").replace(".png", "").trim();
    this.swiperThumbnails.forEach((e, t) => {
      e.classList.remove("selected")
    }), this.swiperThumbnails.forEach((e, t) => {
      var s = e.dataset.imageName.replace(".jpg", "").replace(".png", "").trim();
      i == s && e.classList.add("selected")
    })
  };
  _toggleStickyBar = () => {
    this.stickyBars.forEach(e => {
      0 < this.form.getBoundingClientRect().bottom ? "mobile" == e.dataset.type ? e.classList.add("hidden") : e.classList.remove("tabletl:flex") : "mobile" == e.dataset.type ? e.classList.remove("hidden") : e.classList.add("tabletl:flex")
    })
  };
  _handleStickyBar = () => {
    this.stickyBars = document.querySelectorAll(this._selectors.stickyBar), this.stickyAtcBtns = document.querySelectorAll(this._selectors.stickyAtc), this.buttons = [...this.buttons, ...this.stickyAtcBtns], this.stickySelectOptionsBtns = document.querySelectorAll(this._selectors.stickySelectOptionsBtn);
    var e = document.querySelectorAll(this._selectors.stickyLoader);
    this.loaders = [...this.loaders, ...e], this.stickyAtcClicked = !1, this._toggleStickyBar(), document.addEventListener("scroll", this._toggleStickyBar), this.stickyAtcBtns.forEach(e => {
      e.addEventListener("click", this._stickyAtcOnClick)
    }), this.stickySelectOptionsBtns.forEach(e => {
      e.addEventListener("click", () => {
        this.querySelector("[js-product-info]").scrollIntoView()
      })
    })
  };
  _openImagesModal = e => {
    e.preventDefault(), e.stopPropagation(), window.innerWidth < 1024 || (this.imagesModal.open(), e = e.currentTarget.dataset.index, (e = this.imagesModal.querySelector(this._selectors.modalThumbImage + `[data-index="${e}"]`)) && e.click())
  };
  _updateActiveThumbImage = t => {
    this.modalThumbImages.forEach(e => {
      e.classList.remove("active"), e.dataset.index == t && e.classList.add("active")
    })
  };
  _thumbImageOnClick = e => {
    e.preventDefault(), this.thumbImageClicked = !0;
    var e = e.currentTarget.dataset.index,
      t = this.imagesModal.querySelector(this._selectors.modalMainImage + `[data-index="${e}"]`);
    t && t.scrollIntoView(), this._updateActiveThumbImage(e)
  };
  _findActiveThumbImageOnScroll = () => {
    if (!this.thumbImageClicked) {
      let t = "";
      this.imagesModal.querySelectorAll(this._selectors.modalMainImage + ":not(.hidden)").forEach(e => {
        this.imagesScrollWrapper.scrollTop >= e.offsetTop - .5 * e.offsetHeight && (t = e)
      }), this._updateActiveThumbImage(t.dataset.index)
    }
    this.thumbImageClicked = !1
  };
  _handleImagesModal = () => {
    this.imagesModal = document.querySelector(this._selectors.imagesModal), this.imagesModalTriggers = this.querySelectorAll(this._selectors.imagesModalTrigger), this.modalThumbImages = this.imagesModal.querySelectorAll(this._selectors.modalThumbImage), this.imagesScrollWrapper = this.imagesModal.querySelector(this._selectors.modalImagesScrollWrapper), this.thumbImageClicked = !1, this.imagesModalTriggers.forEach(e => {
      e.addEventListener("click", this._openImagesModal)
    }), this.modalThumbImages.forEach(e => {
      e.addEventListener("click", this._thumbImageOnClick)
    }), this.imagesScrollWrapper.addEventListener("scroll", this._findActiveThumbImageOnScroll)
  };
  _initProductForm() {
    this.form = this.querySelector(this._selectors.form), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.cart = document.querySelector("cart-drawer"), this.dataset.disableCart || (this.cartDrawer = document.querySelector("#CartDrawer"))
  }
  onSubmitHandler(e) {
    if (e.preventDefault(), "false" == this.addToCart.dataset.optionsSelected) this.addToCart.textContent = "Select Option" + (1 < this.numOptions ? "s" : ""), this.addToCart.setAttribute("disabled", "");
    else {
      this._handleErrorMessage(), this._disableButtons();
      e = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest"
        }
      };
      const t = new FormData(this.form);
      this.cart && (t.append("sections", this.cart.getSectionsToRender().map(e => e.id)), t.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement)), e.body = t, fetch("" + window.routes.cart_add_url, e).then(e => e.json()).then(e => {
        e.status ? (theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: t.get("id"),
          errors: e.errors || e.description,
          message: e.message
        }), this._handleErrorMessage(e.description), this.error = !0) : this.cart ? (this.error || theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: t.get("id")
        }), this.error = !1, this.cart.renderContents(e), this.dataset.giftCard ? (e = document.querySelector(".template-product"), document.querySelector(".Rise-popup-backdrop").style.pointerEvents = "none", document.querySelector(".Rise-popup-close-button").style.pointerEvents = "none", document.querySelector("[js-open-cart]").style.pointerEvents = "none", this._waitForElementToNotHaveClass(e, "Rise-popup-opened").then(() => {
          fetch("https://www.berkley-fishing.com/cart").then(e => e.text()).then(e => {
            e = (new DOMParser).parseFromString(e, "text/html").getElementById("cart");
            document.getElementById("cart").innerHTML = e.innerHTML, this.cartDrawer && this.cartDrawer.open(), document.querySelector(".Rise-popup-backdrop").style.pointerEvents = "auto", document.querySelector(".Rise-popup-close-button").style.pointerEvents = "auto", document.querySelector("[js-open-cart]").style.pointerEvents = "auto"
          })
        })) : this.cartDrawer && this.cartDrawer.open()) : window.location = window.routes.cart_url
      }).catch(e => {
        this._handleErrorMessage(e.description), console.error(e)
      }).finally(() => {
        this._enableButtons()
      })
    }
  }
  _handleErrorMessage(e = !1) {
    this.errorMessageWrapper = this.querySelector(this._selectors.error), e ? (this.errorMessageWrapper.innerHTML = e, this.errorMessageWrapper.classList.remove("hidden"), 1 == this.stickyAtcClicked && (this.errorMessageWrapper.scrollIntoView(!1), this.stickyAtcClicked = !1)) : this.errorMessageWrapper.classList.add("hidden")
  }
  _updateVariantNums = t => {
    if (t) {
      var s = this.variantsMetafields[t.id]["Model #"];
      let e = "";
      s && (e += `<li class="product__model-num">
                                <span class="p2 medium">Model Number:&nbsp;</span><span class="p2 regular">${s}</span>
                              </li>`), t.sku && (e = `${e}<li class="product__sku">
                                <span class="p2 medium">SKU:&nbsp;</span><span class="p2 regular">${t.sku}</span>
                              </li>`), this.variantNums && (this.variantNums.innerHTML = e)
    } else this.variantNums && (this.variantNums.innerHTML = e)
  };
  _updateBuyBoxSequence = e => {
    let t = "";
    var s, i = !!e,
      r = i ? this.variantsMetafields[e.id] : this.variantsMetafields[this.defaultVariantSelectionId];
    for (const a in r) r[a] && "Model #" != a && "images" != a && "videos" != a && (s = i ? r[a] : "---", s = `<li class="product-buy-box__sequence-item">
                          <span class="font-500">${a}:</span> <span>${s}</span>
                        </li>`, t += s);
    this.buyBoxSequence && (this.buyBoxSequence.innerHTML = t)
  };
  _updateStickyBarInfo = t => {
    var e = document.querySelectorAll("[js-product-sticky-bar] [js-sticky-option]");
    t ? (e.forEach(e => {
      e.classList.remove("hidden"), e.querySelector("[js-sticky-option-value]").textContent = t[e.dataset.position]
    }), this.stickySelectOptionsBtns.forEach(e => {
      e.classList.add("hidden")
    }), this.stickyAtcBtns.forEach(e => {
      e.parentElement.classList.remove("hidden")
    })) : (e.forEach(e => {
      e.classList.add("hidden")
    }), this.stickySelectOptionsBtns.forEach(e => {
      e.classList.remove("hidden")
    }), this.stickyAtcBtns.forEach(e => {
      e.parentElement.classList.add("hidden")
    }))
  };
  _checkAllOptionsSelected = () => {
    "true" != this.addToCart.dataset.optionsSelected && this.querySelectorAll("product-options [js-product-option-selector]:checked").length == this.numOptions && (this.addToCart.dataset.optionsSelected = "true")
  };
  _updatedCurrentColorLabel = e => {
    e ? (this.currentColorLabel && (this.currentColorLabel.textContent = e[this.colorOptionPosition]), this.saleColorLabel && (this.saleColorLabel.textContent = e[this.colorOptionPosition])) : (this.currentColorLabel && (this.currentColorLabel.textContent = ""), this.saleColorLabel && (this.saleColorLabel.textContent = ""))
  };
  _handleVariantChange = e => {
    var t = e.detail["variant"];
    t && (this.currentPrice = t.price), this._handleErrorMessage(), this._updateProductImages(e), this._checkAllOptionsSelected(), "false" != this.addToCart.dataset.optionsSelected && (this.quantityInput.value = 1, this.hasAttribute("data-color-option-position") && this._updatedCurrentColorLabel(t), this._updatePrice(t, e), this._updateAddToCartState(t), this._updateStickyBarInfo(t), this._updateBuyBoxSequence(t), this._updateVariantNums(t), this._updateThumbnails(e))
  };
  _updateFullWidthGridImage() {
    var e = this.querySelector(this._selectors.productImage + ".full-width"),
      e = (e && e.classList.remove("full-width"), this.querySelector(this._selectors.productImage + ".swiper-slide"));
    e && e.classList.add("full-width")
  }
  _updateProductImages(e) {
    let t;
    var s;
    if (e.detail.variant ? t = e.detail.variant.id : (s = e.target._lastSelectedOption.lastSelected) == this.colorOptionPosition && (i = e.target._lastSelectedOption[s], s = this.querySelector(`product-options [js-product-option-selector][data-index="${s}"][value="${i}"]`), t = s.dataset.variantExample), t) {
      const r = this.variantsMetafields[t].images.split(","),
        a = this.variantsMetafields[t].videos.split(",");
      this.productImagesCarousel.querySelectorAll(this._selectors.productImage).forEach(t => {
        t.classList.add("hidden"), t.classList.remove("swiper-slide", "swiper-slide-active"), r.forEach(e => {
          e = e.replace(".jpg", "").replace(".png", "").trim();
          t.dataset.imageName.includes(e) && "" != e && (t.classList.add("swiper-slide"), t.classList.remove("hidden"))
        }), a.forEach(e => {
          e = e.replace(".jpg", "").replace(".png", "").trim();
          t.dataset.imageName.includes(e) && "" != e && (t.classList.add("swiper-slide"), t.classList.remove("hidden"))
        })
      }), this._updateFullWidthGridImage();
      var i = this.productImagesCarousel.swiper;
      i && i.update(), i.slideTo(0), this.imagesModal.querySelectorAll(this._selectors.productImage).forEach(t => {
        t.classList.add("hidden"), r.forEach(e => {
          e = e.replace(".jpg", "").replace(".png", "").trim();
          t.dataset.imageName.includes(e) && "" != e && t.classList.remove("hidden")
        }), a.forEach(e => {
          e = e.replace(".jpg", "").replace(".png", "").trim();
          t.dataset.imageName.includes(e) && "" != e && t.classList.remove("hidden")
        })
      }), this._updateThumbnails(e)
    }
  }
  _updateThumbnails(e) {
    let t;
    var s;
    if (e.detail.variant ? t = e.detail.variant.id : (s = e.target._lastSelectedOption.lastSelected) == this.colorOptionPosition && (e = e.target._lastSelectedOption[s], s = this.querySelector(`product-options [js-product-option-selector][data-index="${s}"][value="${e}"]`), t = s.dataset.variantExample), t) {
      const i = this.variantsMetafields[t].images.split(","),
        r = this.variantsMetafields[t].videos.split(",");
      let s = !0;
      this.swiperThumbnails.forEach(t => {
        t.classList.add("hidden"), t.classList.remove("selected"), i.forEach(e => {
          e = e.replace(".jpg", "").replace(".png", "").trim();
          t.dataset.imageName.includes(e) && "" != e && (t.classList.remove("hidden"), s) && (t.classList.add("selected"), s = !1)
        }), r.forEach(e => {
          e = e.replace(".jpg", "").replace(".png", "").trim();
          t.dataset.imageName.includes(e) && "" != e && (t.classList.remove("hidden"), s) && (t.classList.add("selected"), s = !1)
        })
      })
    }
  }
  _updateAddToCartState(t) {
    t ? t.available ? this.buttons.forEach(e => {
      e.hasAttribute("js-sticky-atc"), e.innerHTML = "カートに追加 - " + theme.utils.formatMoney(t.price, theme.config.money.format), e.removeAttribute("disabled")
    }) : this.buttons.forEach(e => {
      e.textContent = "Out Of Stock", e.setAttribute("disabled", "")
    }) : this.buttons.forEach(e => {
      e.textContent = "オプションを選択してください", e.setAttribute("disabled", "")
    })
  }
  _updatePrice(e, t) {
    let s = "";
    s = e ? e.compare_at_price && e.compare_at_price > e.price ? `<span class="product__price product__price--price font-600">${theme.utils.formatMoney(e.price, theme.config.money.format)}</span><s class="product__price product__price--compare text-gray-dark pl-xs">${theme.utils.formatMoney(e.compare_at_price, theme.config.money.format)}</s>` : `<span class="product__price product__price--price font-600">${theme.utils.formatMoney(e.price, theme.config.money.format)}</span>` : (e = t.srcElement._product).price_varies ? `<span class="product__price product__price--range font-600">${theme.utils.formatMoney(e.price_min, theme.config.money.format)} 〜 ${theme.utils.formatMoney(e.price_max, theme.config.money.format)}</span>` : e.compare_at_price && e.compare_at_price > e.price ? `<span class="product__price product__price--price font-600">${theme.utils.formatMoney(e.price, theme.config.money.format)}</span><s class="product__price product__price--compare text-gray-dark pl-xs">${theme.utils.formatMoney(e.compare_at_price, theme.config.money.format)}</s>` : `<span class="product__price product__price--price font-600">${theme.utils.formatMoney(e.price, theme.config.money.format)}</span>`, this.prices.forEach(e => {
      e.innerHTML = s
    })
  }
  _disableButtons() {
    this.buttons.forEach(e => {
      e.setAttribute("disabled", "")
    }), this.loaders.forEach(e => {
      e.setAttribute("loading", "")
    })
  }
  _enableButtons() {
    this.buttons.forEach(e => {
      e.removeAttribute("disabled")
    }), this.loaders.forEach(e => {
      e.removeAttribute("loading")
    })
  }
  _initProductSiblings = async () => {
    if (this.productSiblingsContainer = this.querySelector(this._selectors.siblingsContainer), null != this.productSiblingsContainer) {
      var e = this.productSiblingsContainer.getAttribute("data-group");
      const s = this.productSiblingsContainer.getAttribute("data-handle");
      e = await this._getSiblingsJSON(`/collections/all/${e}/?view=json`);
      let t = "";
      e.length <= 1 || (e.forEach(e => {
        t = e.handle != s ? `${t}<a href="${e.url}" class="rounded btn btn--outline text-center flex items-center justify-center">${e.siblingTitle}</a>` : `${t}<button class="rounded btn bg-red border-red text-center flex items-center justify-center" disabled="disabled">${e.siblingTitle}</button>`
      }), this.productSiblingsContainer.insertAdjacentHTML("beforeend", t), this.productSiblingsContainer.classList.remove("hidden"))
    }
  };
  _getSiblingsJSON(e) {
    return fetch(e).then(e => e.text()).then(e => {
      e = (new DOMParser).parseFromString(e, "text/html").querySelector("[js-collection-json]");
      return JSON.parse(e.innerHTML)
    })
  }
  _handleThumnbnailClick(e) {
    const s = e.currentTarget.dataset.imageName;
    this.productImagesCarousel.swiper.slides.forEach((e, t) => {
      e.dataset.imageName == s && this.productImagesCarousel.swiper.slideTo(t)
    })
  }
  _updateKlaviyoModal(e) {
    var t = document.querySelector("#KlaviyoBisModal"),
      t = (t && t.setAttribute("data-variant-id", e.id), t?.querySelector("klaviyo-bis"));
    t && (t.variantId = "$shopify:::$default:::" + e.id)
  }
  _waitForElementToNotHaveClass(s, i) {
    return new Promise(e => {
      const t = setInterval(() => {
        s.classList.contains(i) || (clearInterval(t), e())
      }, 100)
    })
  }
  _loadVariantTab = e => {
    e.preventDefault();
    var e = e.currentTarget,
      t = e.dataset.variantTabId,
      s = e.dataset.variantPrice,
      i = e.dataset.techName,
      r = e.dataset.available,
      a = e.dataset.modelName,
      e = e.dataset.productVariantOption,
      o = document.querySelector("[js-klaviyo-bis-trigger]"),
      n = document.querySelector("[js-variant-tab-price]"),
      c = document.querySelector("[js-quick-view-options]"),
      l = document.querySelector("[js-variant-info-append]"),
      d = document.querySelector("[js-model-append]"),
      h = document.querySelector("[js-variant-tech-append]"),
      u = document.querySelector("[js-variant-tech]"),
      p = document.querySelector('[data-variant-spec-clone="' + t + '"]'),
      m = document.querySelector('[data-variant-option-clone="' + t + '"]'),
      g = document.querySelector("[js-variant-atc-modal]"),
      b = document.querySelector("[js-url-link]"),
      v = b.dataset.ogLink + t,
      _ = document.querySelector("[js-variant-tab-images]"),
      b = (b.href = v, g.dataset.variantId = t, "true" == r ? (g.innerHTML = "カートに追加 - " + s, g.hasAttribute("disabled") && g.removeAttribute("disabled")) : (g.innerHTML = "Out of Stock", g.setAttribute("disabled", "")), p.cloneNode(!0)),
      v = m.cloneNode(!0);
    l.innerHTML = "", d.innerHTML = "", l.append(b), d.innerHTML = a, i && (h.innerHTML = i, u.classList.remove("hidden")), n.innerHTML = "", n.innerHTML = s, c.innerHTML = "", c.append(v), o && (o.dataset.variantId = t, o.dataset.productVariantOption = e);
    const y = this.variantsMetafields[t].images.split(","),
      f = this.variantsMetafields[t].videos.split(",");
    _.querySelectorAll(this._selectors.productImage).forEach(t => {
      t.classList.add("hidden"), t.classList.remove("swiper-slide", "swiper-slide-active"), y.forEach(e => {
        e = e.replace(".jpg", "").replace(".png", "").trim();
        t.dataset.imageName.includes(e) && "" != e && (t.classList.add("swiper-slide"), t.classList.remove("hidden"))
      }), f.forEach(e => {
        e = e.replace(".jpg", "").replace(".png", "").trim();
        t.dataset.imageName.includes(e) && "" != e && (t.classList.add("swiper-slide"), t.classList.remove("hidden"))
      })
    })
  };
  _filterSection = e => {
    e = e.currentTarget;
    const t = e.dataset.techName;
    document.querySelectorAll(this._selectors.variantFilterButtons).forEach(e => {
      e.setAttribute("aria-selected", !1)
    }), e.setAttribute("aria-selected", !0), document.querySelectorAll("[js-variant-data]").forEach(e => {
      "all" != t && e.dataset.tech !== t ? e.classList.contains("hidden") || e.classList.add("hidden") : e.classList.contains("hidden") && e.classList.remove("hidden")
    })
  };
  _addVariant = e => {
    e = {
      items: [{
        id: e.currentTarget.dataset.variantId,
        quantity: 1
      }]
    };
    this.cart && (e.sections = this.cart.getSectionsToRender().map(e => e.id)), fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(e)
    }).then(e => e.json()).then(e => {
      this.cart ? (this.cart.renderContents(e), this.cartDrawer && this.cartDrawer.open()) : document.querySelector("[js-trigger-cart]").click()
    }).catch(e => {
      console.error("Error:", e)
    })
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    new IntersectionObserver(((e, t) => {
      e[0].isIntersecting && (t.unobserve(this), fetch(this.dataset.url).then(e => e.text()).then(e => {
        var t = document.createElement("div"),
          e = (t.innerHTML = e, t.querySelector("product-recommendations"));
        e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML)
      }).catch(e => {
        console.error(e)
      }))
    }).bind(this), {
      rootMargin: "0px 0px 200px 0px"
    }).observe(this)
  }
}
class SearchMain extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      productsGrid: "[js-search-products-grid]",
      toggleView: "[js-search-toggle-view]",
      sortTrigger: "[js-search-sort-trigger]"
    }, this._refresh = ["[js-search-status]", "[js-search-grid]", "[js-search-results-count]", "[js-search-sort-trigger]"]
  }
  connectedCallback() {
    this.productsGrid = this.querySelector(this._selectors.productsGrid), this.toggleViews = this.querySelectorAll(this._selectors.toggleView), this.sortTrigger = this.querySelector(this._selectors.sortTrigger), this._updateFilterDrawerResultsCount(), this._setListeners()
  }
  _setListeners() {
    document.addEventListener("filter:change", this._handleFilterChange), this.toggleViews.forEach(e => {
      e.addEventListener("click", this._updateView)
    }), this.sortTrigger && this.sortTrigger.addEventListener("change", this._handleSortTrigger)
  }
  _handleSortTrigger = e => {
    e.preventDefault();
    e = document.querySelector("[js-filter-form] [js-sort]").querySelector(`input[value="${e.currentTarget.value}"]`);
    e && e.click()
  };
  _updateView = e => {
    e.preventDefault();
    var e = e.currentTarget,
      t = e.dataset.view;
    this.toggleViews.forEach(e => {
      e.removeAttribute("disabled")
    }), e.setAttribute("disabled", ""), this.productsGrid.setAttribute("data-view", t)
  };
  _updateFilterDrawerResultsCount = () => {
    let t = 0;
    this.querySelectorAll("[js-search-results-count]").forEach(e => {
      t += parseInt(e.textContent)
    });
    var e = document.querySelector("filter-sort [js-filter-results-count]");
    e && (e.textContent = t)
  };
  _handleFilterChange = e => {
    e = e.detail.parsedHTML, e = e.querySelector(`[data-id="${this.dataset.id}"]`);
    theme.utils.refreshElements(this._refresh, e, this), this._updateFilterDrawerResultsCount()
  }
}
class CollectionList extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      block: "[js-collection-list-block]",
      title: "[js-collection-list-title]"
    }
  }
  connectedCallback() {
    this.blocks = this.querySelectorAll(this._selectors.block), this.titles = this.querySelectorAll(this._selectors.title), this.images = this.querySelectorAll(this._selectors.image), this._setListeners()
  }
  _setListeners() {
    this.titles.forEach(e => {
      e.addEventListener("mouseover", this._blockChange), e.addEventListener("mouseleave", this._blockChange)
    })
  }
  _blockChange = e => {
    e.target.classList.toggle("opacity-80");
    e.target.closest(".collection-list__container").querySelector(".collection-list-image").classList.toggle("opacity-0");
    e = e.target.closest(".collection-list__container").querySelector(".collection-list__arrow");
    e.classList.toggle("opacity-0"), e.classList.toggle("translate-x-full")
  }
}
customElements.define("s-collection-grid", CollectionGrid), customElements.define("collection-list", CollectionList), customElements.define("s-product", ProductMain), customElements.define("product-recommendations", ProductRecommendations), customElements.define("s-search", SearchMain);
class Account extends HTMLElement {
  constructor() {
    super(), this._selectors = {
      addressCountrySelect: "[js-country-select]",
      editAddressModal: "[js-edit-address-modal]",
      editAddressOpen: "[js-edit-address]",
      editAddressForm: "[js-edit-address-form]",
      deleteAddressButton: "[js-delete-address]",
      ordersContainer: "[js-orders]",
      ordersPagination: "[js-next-page]",
      order: "[js-order]",
      accountSidebar: "[js-account-sidebar]",
      sidebarDropdownBtn: "[js-dropdown-btn]",
      sidebarDropdownContent: "[js-dropdown-content]",
      sidebarDropdownBtnText: "[js-dropdown-btn-text]",
      mainContentContainer: "[js-main-content-container]",
      mainContentTabs: "[js-main-content-tab]",
      breadcrumbs: "[js-breadcrumbs]"
    }
  }
  connectedCallback() {
    this.countrySelects = this.querySelectorAll(this._selectors.addressCountrySelect), this.editAddressModal = this.querySelector(this._selectors.editAddressModal), this.openEditAddress = this.querySelectorAll(this._selectors.editAddressOpen), this.editAddressForms = this.querySelectorAll(this._selectors.editAddressForm), this.deleteAddressButtons = this.querySelectorAll(this._selectors.deleteAddressButton), this.ordersContainer = this.querySelector(this._selectors.ordersContainer), this.ordersPagination = this.querySelector(this._selectors.ordersPagination), this.accountSidebar = this.querySelector(this._selectors.accountSidebar), this.sidebarDropdownBtn = this.querySelector(this._selectors.sidebarDropdownBtn), this.sidebarDropdownContent = this.querySelector(this._selectors.sidebarDropdownContent), this.sidebarDropdownBtnText = this.querySelector(this._selectors.sidebarDropdownBtnText), this.breadcrumbs = this.querySelector(this._selectors.breadcrumbs), this.mainContentContainer = this.querySelector(this._selectors.mainContentContainer), this._setupCountries(), this._setupEventListeners(), this._setupTabChanges(), this._setupOnLoadTab()
  }
  _setupCountries() {
    Shopify && Shopify.CountryProvinceSelector && (new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
      hideElement: "AddressProvinceContainerNew"
    }), this.countrySelects.forEach(e => {
      e = e.dataset.formId;
      new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, {
        hideElement: "AddressProvinceContainer_" + e
      })
    }))
  }
  _setupEventListeners() {
    this.ordersPagination && this.ordersPagination.addEventListener("click", this._addOrders), this.openEditAddress.forEach(e => {
      e.addEventListener("click", this._handleOpenEditAddress)
    }), this.deleteAddressButtons.forEach(e => {
      e.addEventListener("click", this._handleDeleteAddress)
    }), this.editAddressModal && this.editAddressModal.addEventListener("close", this._handleCloseEditAddress), this.sidebarDropdownBtn.addEventListener("click", this._handleDropdownClick)
  }
  _setupOnLoadTab() {
    var t = this.sidebarDropdownContent.querySelectorAll("[js-tab]"),
      e = this.mainContentContainer.querySelectorAll(this._selectors.mainContentTabs),
      s = Array.prototype.slice.call(e),
      i = window.location.hash.replace("#", "").toLowerCase();
    if (0 === i.length && 0 < t.length) {
      const a = t[0].getAttribute("aria-controls");
      e = s.filter(e => e.id === a)[0];
      t[0].setAttribute("aria-selected", !0), e.setAttribute("aria-hidden", !1), void (this.sidebarDropdownBtnText.textContent = t[0].textContent)
    } else
      for (let e = 0; e < t.length; e++) {
        const o = t[e].getAttribute("aria-controls");
        var r = s.filter(e => e.id === o)[0];
        o === i ? (t[e].setAttribute("aria-selected", !0), r.setAttribute("aria-hidden", !1), this.breadcrumbs.textContent = "Account / " + t[e].textContent, this.sidebarDropdownBtnText.textContent = t[e].textContent) : (t[e].setAttribute("aria-selected", !1), r.setAttribute("aria-hidden", !0))
      }
  }
  _addOrders = async () => {
    var e = this.ordersPagination.dataset.url,
      e = await this._getOrders(e),
      t = e.querySelector(this._selectors.ordersContainer).innerHTML,
      e = e.querySelector(this._selectors.ordersPagination);
    this.ordersContainer.insertAdjacentHTML("beforeend", t), e ? this.ordersPagination.dataset.url = e.dataset.url : this.ordersPagination.remove(), this.ordersContainer.connectedCallback()
  };
  _getOrders(e) {
    return fetch(e).then(e => e.text()).then(e => {
      return (new DOMParser).parseFromString(e, "text/html")
    })
  }
  _handleOpenEditAddress = e => {
    e.stopPropagation();
    e = e.currentTarget.dataset.form, e = document.querySelector("#address_form_" + e);
    e.classList.remove("hidden"), this.editAddressModal.open(), e.querySelector('[name="address[first_name]"]').focus()
  };
  _handleDeleteAddress = e => {
    e = e.currentTarget.dataset.target;
    confirm("Are you sure you want to delete this address?") && Shopify.postLink(e, {
      parameters: {
        _method: "delete"
      }
    })
  };
  _handleCloseEditAddress = e => {
    this.editAddressForms.forEach(e => {
      e.classList.add("hidden")
    })
  };
  _handleDropdownClick = e => {
    this.sidebarDropdownContent.classList.contains("hidden") ? this.sidebarDropdownContent.classList.remove("hidden") : this.sidebarDropdownContent.classList.add("hidden")
  };
  _setupTabChanges() {
    var t = this.sidebarDropdownContent.querySelectorAll("[js-tab]");
    for (let e = 0; e < t.length; e++) "true" == t[e].getAttribute("aria-selected") && (this.sidebarDropdownBtnText.textContent = t[e].textContent, this.breadcrumbs.textContent = "Account / " + t[e].textContent);
    t.forEach(r => {
      r.addEventListener("click", e => {
        this.sidebarDropdownBtnText.textContent = r.textContent, this.breadcrumbs.textContent = "Account / " + r.textContent, this.sidebarDropdownContent.classList.contains("hidden") ? this.sidebarDropdownContent.classList.remove("hidden") : this.sidebarDropdownContent.classList.add("hidden");
        var t = this.mainContentContainer.querySelectorAll(this._selectors.mainContentTabs),
          t = Array.prototype.slice.call(t);
        const s = r.getAttribute("aria-controls");
        var t = t.filter(e => e.id === s)[0],
          i = t.id;
        t.id = null, window.location.hash = s, t.id = i
      })
    })
  }
}
customElements.define("s-account", Account);